(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstone-customiser"]) return;
  try {
    
  (function () {
    'use strict';

    var ROOT = document.querySelector('[data-lk-cust]');
    if (!ROOT) return;

    var configEl = ROOT.querySelector('[data-lk-config]');
    if (!configEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }

    var FEE_VARIANT_ID = parseInt(ROOT.getAttribute('data-lk-engraving-fee-variant'), 10) || 0;
    var FEE_PENNIES = parseInt(ROOT.getAttribute('data-lk-engraving-fee-pennies'), 10) || 500;

    var STONES = CONFIG.stones;
    var RINGS_BY_METAL = CONFIG.rings;       // { gold: {january: url, ...}, silver: {...}, rose_gold: {...} }
    var SWATCHES = CONFIG.swatches;

    var DEFAULT_LEFT = 'february';   // Amethyst
    var DEFAULT_RIGHT = 'april';     // Diamond
    var VALID_METALS = ['gold', 'silver', 'rose_gold'];

    // Live state — driven by the variant selector, not the drawer
    var currentMetal = (CONFIG.initialMetal && RINGS_BY_METAL[CONFIG.initialMetal]) ? CONFIG.initialMetal : 'gold';

    function normaliseMetal(v) {
      if (!v) return null;
      var m = String(v).trim().toLowerCase().replace(/\s+/g, '_');
      if (m === 'rose_gold' || m === 'silver' || m === 'gold') return m;
      if (m === 'yellow_gold') return 'gold';   // sensible fallback
      if (m === 'white_gold')  return 'silver'; // sensible fallback
      return null;
    }

    function detectMetalFromVariant(variant) {
      if (!variant || !variant.options) return null;
      for (var i = 0; i < variant.options.length; i++) {
        var n = normaliseMetal(variant.options[i]);
        if (n) return n;
      }
      return null;
    }

    function ringUrl(month, w, metalOverride) {
      var metal = metalOverride || currentMetal;
      var bucket = RINGS_BY_METAL[metal] || RINGS_BY_METAL.gold;
      var u = bucket && bucket[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 900) : '';
    }
    function swatchUrl(month, w) {
      var u = SWATCHES[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 180) : '';
    }
    function stoneByMonth(m) {
      for (var i = 0; i < STONES.length; i++) if (STONES[i].month === m) return STONES[i];
      return null;
    }
    function labelFor(m) {
      var s = stoneByMonth(m);
      return s ? s.stone + ' (' + s.monthLabel + ')' : '';
    }
    function uid() {
      return 'lk-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // --- Mount: clone templates into their final locations ---------------------

    function tpl(name) {
      var t = ROOT.querySelector('[data-lk-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : null;
    }

    var pillsFrag = tpl('pills');
    var drawerFrag = tpl('drawer');
    var overlayFrag = tpl('overlay');
    var propsFrag = tpl('properties');
    if (!pillsFrag || !drawerFrag || !overlayFrag || !propsFrag) return;

    // 1) Inject hidden line-item-property inputs into the product form
    var form = document.querySelector('form[action*="/cart/add"][data-product-form]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var SESSION_ID = uid();
    var propInputs = {};
    Array.prototype.forEach.call(propsFrag.querySelectorAll('[data-lk-prop]'), function (el) {
      propInputs[el.getAttribute('data-lk-prop')] = el;
    });
    propInputs['_LK Session ID'].value = SESSION_ID;
    form.appendChild(propsFrag);

    // 2) Move the pills into the form, BELOW the size selector
    //    Strategy: insert directly after the form's variant selectors block.
    var pillsHost = document.createElement('div');
    pillsHost.className = 'lk-cust lk-cust--pills-host';
    pillsHost.appendChild(pillsFrag);

    var selectorsAnchor = form.querySelector('.product__selectors');
    if (selectorsAnchor) {
      selectorsAnchor.insertAdjacentElement('afterend', pillsHost);
    } else {
      // Fallback: place just before the Add to Cart submit holder
      var submit = form.querySelector('.product__submit__holder') || form.querySelector('[data-add-to-cart]');
      if (submit && submit.parentNode) {
        submit.parentNode.insertBefore(pillsHost, submit);
      } else {
        form.appendChild(pillsHost);
      }
    }

    // 3) Mount the composite overlay over the gallery slides.
    //    Stamp on the currently-visible slide AND on every slide that is a
    //    variant featured_media. The latter ensures switching Color → Silver
    //    or Rose Gold continues showing our composite (the theme would
    //    otherwise scroll/Flickity-select to that variant's bare photo).
    function mountOverlayOnSlide(slide) {
      if (!slide || slide.dataset.lkOverlayMounted === '1') return;
      slide.dataset.lkOverlayMounted = '1';
      var slideMedia = slide.querySelector('.product-single__media') || slide;
      var computed = getComputedStyle(slideMedia);
      if (computed.position === 'static') slideMedia.style.position = 'relative';
      var overlayClone = ROOT.querySelector('[data-lk-tpl="overlay"]').content.cloneNode(true);
      slideMedia.appendChild(overlayClone);
    }

    // First-visible slide (matches behaviour of variant pre-paint via Liquid)
    var firstSlide = document.querySelector('[data-product-single-media-group] [data-product-slide]:not(.media--hidden), [data-product-single-media-group] [data-product-slide]');
    mountOverlayOnSlide(firstSlide);

    // Eagerly stamp on every variant featured_media slide
    var variantMediaIds = Array.isArray(CONFIG.variantMediaIds) ? CONFIG.variantMediaIds : [];
    variantMediaIds.forEach(function (id) {
      mountOverlayOnSlide(document.querySelector('[data-product-slide][data-id="' + id + '"]'));
    });

    // The first overlay clone above already consumed `overlayFrag`; we
    // intentionally drop the unused initial clone since we re-clone via
    // mountOverlayOnSlide() now. (Keeping this comment so the unused
    // `overlayFrag` variable doesn't look like a bug.)

    // 4) Mount the drawer + backdrop on <body>
    var drawerHost = document.createElement('div');
    drawerHost.className = 'lk-cust';
    drawerHost.appendChild(drawerFrag);
    document.body.appendChild(drawerHost);

    // --- DOM refs --------------------------------------------------------------

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    var refs = {
      pills: $('[data-lk="pills"]', pillsHost),
      gemPillBtn: $('[data-lk="open-drawer"]', pillsHost),
      gemPillCounter: $('[data-lk="gem-pill-counter"]', pillsHost),
      engToggle: $('[data-lk="engraving-toggle"]', pillsHost),
      engInputRow: $('[data-lk="engraving-input-row"]', pillsHost),
      engInput: $('[data-lk="engraving-input"]', pillsHost),
      engCounter: $('[data-lk="engraving-counter"]', pillsHost),

      pdpLefts: $$('[data-lk="pdp-left"]'),
      pdpRights: $$('[data-lk="pdp-right"]'),

      backdrop: $('[data-lk="backdrop"]', drawerHost),
      drawer: $('[data-lk="drawer"]', drawerHost),
      drawerClose: $('[data-lk="drawer-close"]', drawerHost),
      drawerLeft: $('[data-lk="drawer-left"]', drawerHost),
      drawerRight: $('[data-lk="drawer-right"]', drawerHost),
      drawerBody: $('[data-lk="drawer-body"]', drawerHost),
      sectionLeft: drawerHost.querySelector('[data-lk-section="left"] .lk-cust__grid'),
      sectionRight: drawerHost.querySelector('[data-lk-section="right"] .lk-cust__grid'),
      section2Heading: $('[data-lk="section-2-heading"]', drawerHost),
      drawerTitleCounter: $('[data-lk="drawer-title-counter"]', drawerHost),
      drawerCtaBtn: $('[data-lk="drawer-confirm"]', drawerHost),
      drawerCtaCounter: $('[data-lk="drawer-cta-counter"]', drawerHost),
      srAnnounce: $('[data-lk="sr-announce"]', drawerHost),

      atcBtn: form.querySelector('[data-add-to-cart]'),
      atcText: form.querySelector('[data-add-to-cart-text]')
    };

    if (!refs.atcBtn || !refs.atcText) return;
    var ORIGINAL_ATC_TEXT = refs.atcText.textContent;

    // --- Build swatch grids ----------------------------------------------------

    function buildGrid(container, position) {
      var frag = document.createDocumentFragment();
      STONES.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lk-cust__swatch';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-label', s.monthLabel + ' — ' + s.stone);
        btn.setAttribute('data-lk-swatch', s.month);
        btn.setAttribute('data-lk-position', position);
        btn.setAttribute('tabindex', '-1');
        btn.innerHTML =
          '<img class="lk-cust__swatch__img" src="' + swatchUrl(s.month, 180) + '" alt="" loading="lazy" width="80" height="80">' +
          '<span class="lk-cust__swatch__label">' + s.monthLabel + '</span>' +
          '<span class="lk-cust__swatch__stone">' + s.stone + '</span>';
        frag.appendChild(btn);
      });
      container.appendChild(frag);
    }
    buildGrid(refs.sectionLeft, 'left');
    buildGrid(refs.sectionRight, 'right');

    // --- State -----------------------------------------------------------------

    // Confirmed (committed) selection that drives PDP image + cart properties
    var confirmed = { left: DEFAULT_LEFT, right: DEFAULT_RIGHT };
    // Working (in-drawer) selection. Starts equal to confirmed.
    var working = { left: DEFAULT_LEFT, right: DEFAULT_RIGHT };
    var hasConfirmedOnce = false; // becomes true after first Confirm; before that, gem counter shows 0/2 per spec

    var engravingOn = false;
    var triggerEl = null; // for focus restore on close

    // --- Autoplay cycle (runs until customer first interacts) ------------------
    // Cycles the PDP composite slowly so the customer sees variety; stops the
    // moment they open the drawer or tap a swatch.
    var AUTO_PAIRS = [
      ['march', 'september'],
      ['october', 'june'],
      ['february', 'april'],
      ['may', 'november']
    ];
    var AUTO_FRAME_MS = 1100;
    var AUTO_FIRST_DELAY_MS = 700; // hold default Feb+Apr briefly so ad consistency lands
    var autoTimer = null;
    var autoStartTimer = null;
    var autoStopped = false;
    var autoIdx = -1; // -1 means "currently showing default"; 0..n cycles through AUTO_PAIRS

    function preloadCyclePairs() {
      // Fire-and-forget preload of all months used in the cycle (default Feb+Apr already <link rel=preload>ed)
      var months = {};
      AUTO_PAIRS.forEach(function (p) { months[p[0]] = 1; months[p[1]] = 1; });
      Object.keys(months).forEach(function (m) {
        var im = new Image();
        im.src = ringUrl(m, 900);
      });
    }

    function startAutoplay() {
      if (autoStopped) return;
      preloadCyclePairs();
      autoStartTimer = setTimeout(function () {
        autoTimer = setInterval(autoTick, AUTO_FRAME_MS);
        autoTick(); // first advance immediately after the hold
      }, AUTO_FIRST_DELAY_MS);
    }

    function autoTick() {
      if (autoStopped) return;
      if (document.hidden) return; // pause while tab is in background
      autoIdx = (autoIdx + 1) % AUTO_PAIRS.length;
      var p = AUTO_PAIRS[autoIdx];
      renderPdpComposite(p[0], p[1]);
    }

    function stopAutoplay() {
      if (autoStopped) return;
      autoStopped = true;
      if (autoStartTimer) { clearTimeout(autoStartTimer); autoStartTimer = null; }
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      // Snap back to the confirmed selection (default until customer picks)
      renderPdpComposite(confirmed.left, confirmed.right);
    }

    document.addEventListener('visibilitychange', function () {
      // setInterval pauses naturally when hidden; we just skip the tick via document.hidden check.
    });

    // --- Renderers -------------------------------------------------------------

    function renderPdpComposite(left, right) {
      var leftSrc = ringUrl(left, 900);
      var rightSrc = ringUrl(right, 900);
      var ls = stoneByMonth(left), rs = stoneByMonth(right);
      var leftAlt = ls ? ls.stone : '';
      var rightAlt = rs ? rs.stone : '';
      // Refresh refs in case overlays were stamped after init (e.g., variant change)
      refs.pdpLefts  = $$('[data-lk="pdp-left"]');
      refs.pdpRights = $$('[data-lk="pdp-right"]');
      refs.pdpLefts.forEach(function (img)  { img.src = leftSrc;  if (leftAlt)  img.alt = leftAlt; });
      refs.pdpRights.forEach(function (img) { img.src = rightSrc; if (rightAlt) img.alt = rightAlt; });
    }

    function renderDrawerPreview(left, right) {
      if (refs.drawerLeft)  refs.drawerLeft.src  = ringUrl(left, 600);
      if (refs.drawerRight) refs.drawerRight.src = ringUrl(right, 600);
    }

    function renderSwatchSelected() {
      ['left', 'right'].forEach(function (pos) {
        var current = working[pos];
        $$('[data-lk-position="' + pos + '"]', drawerHost).forEach(function (b) {
          var checked = b.getAttribute('data-lk-swatch') === current;
          b.setAttribute('aria-checked', checked ? 'true' : 'false');
          b.setAttribute('tabindex', checked ? '0' : '-1');
        });
      });
    }

    function workingCount() {
      var n = 0;
      if (working.left)  n++;
      if (working.right) n++;
      return n;
    }
    function confirmedCount() {
      if (!hasConfirmedOnce) return 0;
      var n = 0;
      if (confirmed.left)  n++;
      if (confirmed.right) n++;
      return n;
    }

    function renderCounters() {
      var w = workingCount();
      var c = confirmedCount();
      refs.drawerTitleCounter.textContent = w + '/2';
      refs.drawerCtaCounter.textContent = w + '/2';
      refs.gemPillCounter.textContent = c + '/2';
      refs.drawerCtaBtn.disabled = (w < 2);
    }

    function renderEngravingState() {
      var t = (refs.engInput.value || '').trim();
      refs.engCounter.textContent = (refs.engInput.value || '').length + '/12';
      refs.engInputRow.classList.toggle('is-visible', engravingOn);
      refs.engToggle.setAttribute('aria-checked', engravingOn ? 'true' : 'false');
      // Reflect into hidden form input
      var prop = propInputs['Engraving'];
      if (engravingOn && t.length > 0) {
        prop.disabled = false;
        prop.value = t;
      } else {
        prop.disabled = true;
        prop.value = '';
      }
    }

    function renderAtcState() {
      // Conditions:
      // 1) size selected (or product has only default variant) – determined by form's hidden id input matching an available variant
      // 2) confirmed gemstones (always true, default state pre-fills)
      // 3) if engraving toggled on: text non-empty
      var sizeOk = isSizeSelected();
      var stonesOk = !!(confirmed.left && confirmed.right);
      var engOk = !engravingOn || (refs.engInput.value || '').trim().length > 0;

      if (engravingOn && (refs.engInput.value || '').trim().length === 0) {
        refs.atcText.textContent = 'Enter engraving text';
      } else {
        refs.atcText.textContent = ORIGINAL_ATC_TEXT;
      }

      // We don't override theme's `disabled` attr (sold-out etc).
      // Use a click-capture guard to block the click when our conditions fail.
      ROOT._lkCanSubmit = sizeOk && stonesOk && engOk;
    }

    function isSizeSelected() {
      // The theme's hidden [name="id"] is updated when a valid variant is chosen.
      // For products with only one variant, this is always set.
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return false;
      var v = idInput.value;
      if (!v) return false;
      // Also ensure no required radio fieldset is unselected (theme convention: master radios)
      var unselected = form.querySelectorAll('.product__selectors input[type="radio"]:not(:checked)');
      // Group radios by name and check at least one in each group is checked.
      var groups = {};
      $$('.product__selectors input[type="radio"]', form).forEach(function (r) {
        groups[r.name] = groups[r.name] || { any: false };
        if (r.checked) groups[r.name].any = true;
      });
      for (var k in groups) if (groups.hasOwnProperty(k) && !groups[k].any) return false;
      return true;
    }

    // --- Drawer open/close -----------------------------------------------------

    var lastFocusable = null;
    var firstFocusable = null;

    function openDrawer() {
      // Customer is engaging — kill the autoplay cycle and snap PDP to confirmed state
      stopAutoplay();

      // Sync working with confirmed
      working.left = confirmed.left;
      working.right = confirmed.right;
      renderDrawerPreview(working.left, working.right);
      renderSwatchSelected();
      renderCounters();

      triggerEl = document.activeElement;
      refs.backdrop.classList.add('is-open');
      refs.drawer.classList.add('is-open');
      document.documentElement.classList.add('lk-cust-locked');
      document.body.classList.add('lk-cust-locked');
      // Scroll the body to top of section 1
      requestAnimationFrame(function () {
        refs.drawerBody.scrollTop = 0;
      });

      // Move focus to the close button
      setTimeout(function () { refs.drawerClose.focus(); }, 50);

      track('birthstone_drawer_opened', {});
    }

    function closeDrawer() {
      refs.backdrop.classList.remove('is-open');
      refs.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('lk-cust-locked');
      document.body.classList.remove('lk-cust-locked');
      if (triggerEl && typeof triggerEl.focus === 'function') {
        try { triggerEl.focus(); } catch (e) {}
      }
    }

    refs.gemPillBtn.addEventListener('click', openDrawer);
    refs.drawerClose.addEventListener('click', closeDrawer);
    refs.backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && refs.drawer.classList.contains('is-open')) {
        e.stopPropagation();
        closeDrawer();
      }
    });

    // Focus trap inside drawer
    refs.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', refs.drawer).filter(function (n) {
        return !n.hasAttribute('disabled') && n.offsetParent !== null;
      });
      if (!focusables.length) return;
      firstFocusable = focusables[0];
      lastFocusable = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    });

    // Mobile swipe-down to close
    (function () {
      var startY = null;
      refs.drawer.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 768) return;
        if (refs.drawerBody.scrollTop > 0) return; // only when at top of body
        startY = e.touches[0].clientY;
      }, { passive: true });
      refs.drawer.addEventListener('touchmove', function (e) {
        if (startY == null) return;
        var dy = e.touches[0].clientY - startY;
        if (dy > 80) { closeDrawer(); startY = null; }
      }, { passive: true });
      refs.drawer.addEventListener('touchend', function () { startY = null; }, { passive: true });
    })();

    // --- Swatch selection ------------------------------------------------------

    drawerHost.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lk-swatch]');
      if (!btn) return;
      var month = btn.getAttribute('data-lk-swatch');
      var pos = btn.getAttribute('data-lk-position');
      if (!month || !pos) return;

      stopAutoplay();
      if (working[pos] === month) return; // tap same swatch = no-op

      var prevPos = pos === 'left' ? !!working.left : !!working.right;
      working[pos] = month;
      renderDrawerPreview(working.left, working.right);
      renderPdpComposite(working.left, working.right); // live update behind drawer too
      renderSwatchSelected();
      renderCounters();

      var s = stoneByMonth(month);
      track('birthstone_selected', { stone_name: s ? s.stone : '', month: s ? s.monthLabel : '', position: pos });
      announce((s ? s.stone : '') + ' selected for ' + (pos === 'left' ? 'birthstone 1' : 'birthstone 2'));

      // After picking left for the first time in this opening, scroll to section 2
      if (pos === 'left' && !prevPos && refs.section2Heading) {
        try { refs.section2Heading.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
      }
    });

    // Keyboard nav: arrow keys cycle within a section, Enter/Space selects
    drawerHost.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-lk-swatch]');
      if (!btn) return;
      var pos = btn.getAttribute('data-lk-position');
      var siblings = $$('[data-lk-position="' + pos + '"]', drawerHost);
      var idx = siblings.indexOf(btn);
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = siblings[(idx + 1) % siblings.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = siblings[(idx - 1 + siblings.length) % siblings.length];
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); btn.click(); return; }
      if (next) { e.preventDefault(); next.focus(); }
    });

    // --- Confirm ---------------------------------------------------------------

    refs.drawerCtaBtn.addEventListener('click', function () {
      if (refs.drawerCtaBtn.disabled) return;
      confirmed.left = working.left;
      confirmed.right = working.right;
      hasConfirmedOnce = true;

      propInputs['Birthstone 1'].value = labelFor(confirmed.left);
      propInputs['Birthstone 2'].value = labelFor(confirmed.right);

      renderPdpComposite(confirmed.left, confirmed.right);
      renderCounters();
      renderAtcState();

      track('birthstone_confirmed', { left_stone: stoneName(confirmed.left), right_stone: stoneName(confirmed.right), metal: currentMetal });
      closeDrawer();
    });

    function stoneName(m) { var s = stoneByMonth(m); return s ? s.stone : ''; }

    // --- Engraving -------------------------------------------------------------

    refs.engToggle.addEventListener('change', function () {
      engravingOn = !!refs.engToggle.checked;
      renderEngravingState();
      renderAtcState();
      track('engraving_toggled', { enabled: engravingOn });
      if (engravingOn) {
        setTimeout(function () { refs.engInput.focus(); }, 60);
      }
    });

    refs.engInput.addEventListener('input', function () {
      // Strip non-allowed chars (alphanumeric + space only); enforce length client-side too
      var cleaned = (refs.engInput.value || '')
        .replace(/[^A-Za-z0-9 ]/g, '')
        .slice(0, 12);
      if (cleaned !== refs.engInput.value) refs.engInput.value = cleaned;
      renderEngravingState();
      renderAtcState();
    });

    // --- ATC interception ------------------------------------------------------
    // Capture-phase listeners on the form pre-empt the theme's own button-click /
    // form-submit handlers (which run on the button itself or in bubble phase).
    // We intercept BOTH click and submit to cover keyboard Enter, screen-reader
    // activation, and theme variations.

    var feePreAdded = false;

    function shouldInterceptForFee() {
      return engravingOn && !feePreAdded && FEE_VARIANT_ID > 0;
    }

    function blockWithReason(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (engravingOn && (refs.engInput.value || '').trim().length === 0) {
        refs.engInput.focus();
        return;
      }
      // Theme handles size/sold-out via its own button disable; surface a generic nudge.
      var firstUnchecked = form.querySelector('.product__selectors input[type="radio"]:not(:checked)');
      if (firstUnchecked) {
        var label = form.querySelector('label[for="' + firstUnchecked.id + '"]');
        if (label && label.scrollIntoView) label.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function preAddFeeAndContinue(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var engText = (refs.engInput.value || '').trim();
      var body = JSON.stringify({
        items: [{
          id: FEE_VARIANT_ID,
          quantity: 1,
          properties: {
            '_For Ring': SESSION_ID,
            '_Engraving Text': engText
          }
        }]
      });

      refs.atcBtn.setAttribute('aria-busy', 'true');
      refs.atcBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function () {
          feePreAdded = true;
          // Re-fire the click on the button. Our handler will see feePreAdded === true
          // and pass through to the theme's handler, which will add the ring + refresh drawer.
          refs.atcBtn.click();
        })
        .catch(function (err) {
          console.error('[lk-cust] Engraving fee add failed:', err);
          refs.atcBtn.removeAttribute('aria-busy');
          refs.atcBtn.classList.remove('is-loading');
          var msg = (err && err.description) || 'Could not add engraving. Please try again.';
          var errBox = form.querySelector('[data-cart-errors-container]');
          if (errBox) { errBox.textContent = msg; errBox.style.color = '#b00020'; }
          else { window.alert(msg); }
        });
    }

    function handleAtcEvent(e) {
      // For click events, only intercept on the ATC button (or descendant); the form
      // contains other buttons (size popouts etc) that we must let through.
      if (e.type === 'click') {
        var t = e.target.closest('[data-add-to-cart]');
        if (!t) return;
      }
      if (!ROOT._lkCanSubmit) { blockWithReason(e); return; }
      if (shouldInterceptForFee()) { preAddFeeAndContinue(e); return; }
      // else: let theme proceed with normal AJAX add-to-cart
    }

    if (FEE_VARIANT_ID === 0) {
      console.warn('[lk-cust] engraving-fee variant ID is missing. Check that the engraving-fee product is published to the Online Store sales channel — orders with engraving will be undercharged until this is fixed.');
    }

    form.addEventListener('click', handleAtcEvent, true);
    form.addEventListener('submit', handleAtcEvent, true);

    // Reset pre-added flag once the theme confirms the ring add succeeded so a
    // subsequent add-to-cart (different variant, etc) re-runs the fee step.
    document.addEventListener('theme:cart:added', function () {
      feePreAdded = false;
      refs.atcBtn.removeAttribute('aria-busy');
      refs.atcBtn.classList.remove('is-loading');
    });

    // Watch for the theme updating the variant id (when size changes) to refresh ATC text
    var idInput = form.querySelector('[name="id"]');
    if (idInput) {
      // Use MutationObserver on value attr (theme typically setAttribute('value', ...))
      var mo = new MutationObserver(renderAtcState);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      // Also catch direct .value assignments via change events bubbled from radios
      form.addEventListener('change', function () { setTimeout(renderAtcState, 0); });
    }

    // --- Tracking --------------------------------------------------------------

    function track(name, params) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          var p = { event: name };
          for (var k in params) if (params.hasOwnProperty(k)) p[k] = params[k];
          window.dataLayer.push(p);
        }
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent('lk:' + name, { bubbles: true, detail: params || {} }));
      } catch (e) {}
    }

    function announce(msg) {
      if (refs.srAnnounce) {
        refs.srAnnounce.textContent = '';
        setTimeout(function () { refs.srAnnounce.textContent = msg; }, 30);
      }
    }

    // --- Cart image meta + swap ------------------------------------------------
    // Persist enough metadata for snippets/lk-cart-image-swap.liquid to render
    // a true composite (two clip-path'd <img> halves) directly into the cart
    // line item. We do NOT use <canvas> any more — Shopify's CDN doesn't always
    // include CORS headers on these PNGs, which would taint the canvas and
    // silently fail. The HTML/CSS approach has zero such dependency.

    var COMPOSITE_STORAGE_KEY = 'lk_composites';

    function readComposites() {
      try {
        var raw = JSON.parse(localStorage.getItem(COMPOSITE_STORAGE_KEY) || '{}');
        // Reject legacy entries (canvas dataURLs were strings; new entries are objects)
        var clean = {};
        Object.keys(raw).forEach(function (k) {
          var v = raw[k];
          if (v && typeof v === 'object' && v.left && v.right && v.metal) clean[k] = v;
        });
        return clean;
      } catch (e) { return {}; }
    }
    function writeComposites(map) {
      try {
        var keys = Object.keys(map);
        if (keys.length > 16) {
          var trimmed = {};
          keys.slice(-16).forEach(function (k) { trimmed[k] = map[k]; });
          map = trimmed;
        }
        localStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map));
      } catch (e) {
        try { sessionStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map)); } catch (e2) {}
      }
    }

    function storeCompositeMeta() {
      var map = readComposites();
      map[SESSION_ID] = {
        left: confirmed.left,
        right: confirmed.right,
        metal: currentMetal
      };
      writeComposites(map);
      // The global snippet (lk-cart-image-swap.liquid) listens for this and
      // applies the swap in any cart DOM — drawer or /cart page.
      try {
        document.dispatchEvent(new CustomEvent('lk:composite:updated', { bubbles: true, detail: { sessionId: SESSION_ID } }));
      } catch (e) {}
    }

    // No-op kept for compatibility with metal-change handler, which calls it.
    function invalidateComposite() { /* meta-based: nothing to invalidate */ }

    // Persist on Confirm and on ATC click. The metal-change handler also calls
    // storeCompositeMeta() (via the metal sync block below).
    refs.drawerCtaBtn.addEventListener('click', function () {
      // Defer so the click handler that updates `confirmed` runs first
      setTimeout(storeCompositeMeta, 0);
    });
    refs.atcBtn.addEventListener('click', function () {
      storeCompositeMeta();
    }, true);

    // Persist once at init so the default state (Amethyst+Diamond, current metal)
    // is already in localStorage even before any explicit interaction.
    storeCompositeMeta();

    // --- Metal (variant) sync --------------------------------------------------
    // The Color variant lives on the product form. We listen on the document for
    // the theme's `theme:variant:change` (dispatched after the form has
    // recomputed the new variant — see assets/theme.dev.js:8287). As a
    // belt-and-braces fallback we also listen for raw `change` events on any
    // [name="options[…]"] inputs and re-detect from the active form values, in
    // case the page has dispatch quirks.

    function applyMetal(metal) {
      if (!metal || metal === currentMetal) return;
      currentMetal = metal;
      // Visible surfaces: PDP overlay + (if open) drawer preview.
      // The cycle is normally stopped on first interaction; we still re-render
      // here so the autoplay frames also respect the new metal.
      var pdpL, pdpR;
      if (autoStopped) {
        pdpL = confirmed.left; pdpR = confirmed.right;
      } else {
        // mid-autoplay — keep the currently displayed pair to avoid flicker
        var p = (autoIdx >= 0) ? AUTO_PAIRS[autoIdx] : [DEFAULT_LEFT, DEFAULT_RIGHT];
        pdpL = p[0]; pdpR = p[1];
      }
      renderPdpComposite(pdpL, pdpR);
      renderDrawerPreview(working.left, working.right);
      // Cart composite is metal-dependent — re-persist the meta so any cart
      // DOM rendered after this point picks up the new metal.
      storeCompositeMeta();

      track('metal_changed', {
        metal: currentMetal,
        left_stone: stoneName(confirmed.left) || null,
        right_stone: stoneName(confirmed.right) || null
      });
    }

    document.addEventListener('theme:variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      // Safety net: ensure the just-activated variant slide has our overlay
      // stamped in case it wasn't in the eager list (rare, e.g. mid-session
      // product updates or theme oddities).
      if (v && v.featured_media && v.featured_media.id != null) {
        mountOverlayOnSlide(document.querySelector('[data-product-slide][data-id="' + v.featured_media.id + '"]'));
      }
      var metal = detectMetalFromVariant(v);
      if (metal) applyMetal(metal);
    });

    // Fallback: direct change events on Color/Finish/etc. option inputs in the form.
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name.indexOf('options[') !== 0) return;
      // Walk every option input in the form, find the one whose value normalises
      // to a metal we know about. This handles whatever the option's actual name
      // is (Color / Colour / Finish / Metal).
      var inputs = form.querySelectorAll('[data-single-option-selector], [name^="options["]');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        // Only consider the "winning" value per option:
        if (el.type === 'radio' && !el.checked) continue;
        var n = normaliseMetal(el.value);
        if (n) { applyMetal(n); return; }
      }
    });

    // --- Drawer-open prefetch: warm the same combo in the other two metals ----
    // First metal toggle after engaging with the customiser will then be instant.
    var prefetchedCombos = {};
    function prefetchOtherMetalsForCombo(left, right) {
      VALID_METALS.forEach(function (m) {
        if (m === currentMetal) return;
        [left, right].forEach(function (month) {
          var key = m + ':' + month;
          if (prefetchedCombos[key]) return;
          prefetchedCombos[key] = true;
          var im = new Image();
          im.src = ringUrl(month, 900, m);
        });
      });
    }
    refs.gemPillBtn.addEventListener('click', function () {
      prefetchOtherMetalsForCombo(confirmed.left, confirmed.right);
    });

    // --- First paint -----------------------------------------------------------

    renderPdpComposite(confirmed.left, confirmed.right);
    renderDrawerPreview(working.left, working.right);
    renderSwatchSelected();
    propInputs['Birthstone 1'].value = labelFor(confirmed.left);
    propInputs['Birthstone 2'].value = labelFor(confirmed.right);
    renderCounters();
    renderEngravingState();
    renderAtcState();

    // Begin the slow autoplay cycle behind the customer's first interaction
    startAutoplay();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweet-pea-customiser"]) return;
  try {
    
  (function () {
    'use strict';

    var ROOT = document.querySelector('[data-sp-cust]');
    if (!ROOT) return;

    var configEl = ROOT.querySelector('[data-sp-config]');
    if (!configEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }

    var STONES = CONFIG.stones;
    var RENDERS = CONFIG.renders;
    var SWATCHES = CONFIG.swatches;
    var PEA_POSITIONS = CONFIG.peaPositions;
    var FEATHER = CONFIG.seamFeatherPct;
    var BAND_MARGIN = CONFIG.bandMarginPct;
    var BAND_FEATHER = CONFIG.bandFeatherPct;
    var PLACEHOLDER = CONFIG.placeholderMonth;
    var VARIANTS = CONFIG.variants || [];
    var COUNTS = [2, 3, 4, 5];

    var $ = function (sel, ctx) { return (ctx || ROOT).querySelector(sel); };
    var $$ = function (sel, ctx) {
      return Array.prototype.slice.call((ctx || ROOT).querySelectorAll(sel));
    };
    var sp = function (name, ctx) { return $('[data-sp="' + name + '"]', ctx); };

    var form = document.querySelector('form[action*="/cart/add"][data-product-form]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // --- Mount: clone the templates into their final locations ---------------

    function tpl(name) {
      var t = ROOT.querySelector('[data-sp-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : null;
    }

    var pillsFrag = tpl('pills');
    var drawerFrag = tpl('drawer');
    if (!pillsFrag || !drawerFrag) return;

    // Pill goes below the variant selectors and above add-to-cart — the same
    // anchor strategy the Toi & Moi customiser uses, so the two products put
    // the control in the same place.
    var pillsHost = document.createElement('div');
    pillsHost.className = 'sp-cust sp-cust--pills-host';
    pillsHost.appendChild(pillsFrag);

    var selectorsAnchor = form.querySelector('.product__selectors');
    if (selectorsAnchor) {
      selectorsAnchor.insertAdjacentElement('afterend', pillsHost);
    } else {
      var submitHolder = form.querySelector('.product__submit__holder') ||
                         form.querySelector('[data-add-to-cart]');
      if (submitHolder && submitHolder.parentNode) {
        submitHolder.parentNode.insertBefore(pillsHost, submitHolder);
      } else {
        form.appendChild(pillsHost);
      }
    }

    var drawerHost = document.createElement('div');
    drawerHost.className = 'sp-cust';
    drawerHost.appendChild(drawerFrag);
    document.body.appendChild(drawerHost);

    var refs = {
      pillBtn: sp('open-drawer', pillsHost),
      pillCounter: sp('pill-counter', pillsHost),

      backdrop: sp('backdrop', drawerHost),
      drawer: sp('drawer', drawerHost),
      drawerClose: sp('drawer-close', drawerHost),
      drawerBody: sp('drawer-body', drawerHost),
      drawerTitleCounter: sp('drawer-title-counter', drawerHost),
      drawerConfirm: sp('drawer-confirm', drawerHost),
      drawerCtaCounter: sp('drawer-cta-counter', drawerHost),

      composite: sp('composite', drawerHost),
      previewNote: sp('preview-note', drawerHost),
      metalGroup: sp('metal-group', drawerHost),
      countGroup: sp('count-group', drawerHost),
      slots: sp('slots', drawerHost),
      grid: sp('grid', drawerHost),
      notice: sp('notice', drawerHost),
      undo: sp('undo', drawerHost),
      undoText: sp('undo-text', drawerHost),
      undoBtn: sp('undo-btn', drawerHost),
      reset: sp('reset', drawerHost),
      srAnnounce: sp('sr-announce', drawerHost)
    };

    refs.atcBtn = form.querySelector('[data-add-to-cart]');
    if (refs.notice && !refs.notice.id) refs.notice.id = 'sp-cust-notice';

    // --- State ---------------------------------------------------------------
    // `stones` is an ordered array of length `count`; null = not yet chosen.
    // Duplicates are allowed and meaningful (siblings born the same month), so
    // this is deliberately an array, never a set or a per-month map.
    var state = {
      metal: CONFIG.initialMetal,
      count: CONFIG.initialCount,
      stones: [],
      active: 0
    };

    function stoneByMonth(m) {
      for (var i = 0; i < STONES.length; i++) if (STONES[i].month === m) return STONES[i];
      return null;
    }
    function label(month) {
      var s = stoneByMonth(month);
      return s ? s.stone + ' (' + s.monthLabel + ')' : '';
    }
    // w of 0 / null returns the untransformed original. Needed because a
    // handful of the render files in Shopify Files reject resize transforms
    // (see loadRender below).
    function withWidth(url, w) {
      if (!url) return '';
      if (!w) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    // Pass w === 0 for the untransformed original; omit it for the 900px default.
    function renderUrl(month, count, metal, w) {
      var byMetal = RENDERS[metal || state.metal] || {};
      var byCount = byMetal[String(count || state.count)] || {};
      return withWidth(byCount[month], (w === undefined || w === null) ? 900 : w);
    }
    // Derived from the URL rather than rebuilt, so the filename pattern stays
    // defined in exactly one place (the Liquid loop above).
    function renderFilename(month, count, metal) {
      var byMetal = RENDERS[metal || state.metal] || {};
      var byCount = byMetal[String(count || state.count)] || {};
      var u = byCount[month];
      if (!u) return '';
      return u.split('?')[0].split('/').pop();
    }
    function uid() {
      return 'sp-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // Seams are the midpoints between adjacent pea centres.
    function seamsFor(count) {
      var peas = PEA_POSITIONS[String(count)] || [];
      var out = [];
      for (var i = 0; i < peas.length - 1; i++) out.push((peas[i].cx + peas[i + 1].cx) / 2);
      return out;
    }

    // Vertical extent of the pod for a given count, derived from the same pea
    // positions so there is one source of truth for the geometry.
    function bandFor(count) {
      var peas = PEA_POSITIONS[String(count)] || [];
      if (!peas.length) return null;
      var top = Infinity, bottom = -Infinity;
      for (var i = 0; i < peas.length; i++) {
        top = Math.min(top, peas[i].cy - peas[i].r);
        bottom = Math.max(bottom, peas[i].cy + peas[i].r);
      }
      return { top: top - BAND_MARGIN, bottom: bottom + BAND_MARGIN };
    }

    // --- Variant sync --------------------------------------------------------

    function findVariant(metal, count) {
      for (var i = 0; i < VARIANTS.length; i++) {
        if (VARIANTS[i].metal === metal && VARIANTS[i].count === count) return VARIANTS[i];
      }
      return null;
    }

    // Drive the theme's own option inputs and let the theme do the rest
    // (price, availability, [name="id"], theme:variant:change). Handles both
    // the radio/swatch markup and the popout-select markup in snippets/product.liquid.
    var suppressVariantEcho = false;
    function setThemeOption(optionName, value) {
      if (!optionName || !value) return;
      var esc = optionName.replace(/"/g, '\\"');
      var radios = $$('input[type="radio"][name="options[' + esc + ']"]', form);
      var i;
      for (i = 0; i < radios.length; i++) {
        if (radios[i].value === value) {
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
      var hidden = $('input[data-popout-input][name="options[' + esc + ']"]', form) ||
                   $('input[type="hidden"][name="options[' + esc + ']"]', form);
      if (hidden) {
        if (hidden.value !== value) {
          hidden.value = value;
          var popout = hidden.closest('[data-popout]');
          if (popout) {
            var text = popout.querySelector('[data-popout-text]');
            if (text) text.textContent = value;
            $$('[data-popout-option]', popout).forEach(function (a) {
              var on = a.getAttribute('data-value') === value;
              if (on) a.setAttribute('aria-current', 'true');
              else a.removeAttribute('aria-current');
              a.parentElement.classList.toggle('select-popout__item--current', on);
            });
          }
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function applyVariant() {
      suppressVariantEcho = true;
      setThemeOption(CONFIG.optionNames.metal, (CONFIG.metalValues || {})[state.metal]);
      setThemeOption(CONFIG.optionNames.count, (CONFIG.countValues || {})[String(state.count)]);
      setTimeout(function () { suppressVariantEcho = false; }, 0);
    }

    // --- Compositing ---------------------------------------------------------
    // One layer per position. Layer 0 is unmasked; layer n is revealed from
    // seam[n-1] rightwards with a feathered ramp, and later layers paint over
    // it — so layer n ends up occupying exactly [seam[n-1], seam[n]].
    // Each layer holds two <img>s so a stone change can crossfade without the
    // base layer flashing through.

    var layers = [];

    function setMask(el, gradient) {
      el.style.webkitMaskImage = gradient;
      el.style.maskImage = gradient;
    }

    function buildLayers() {
      refs.composite.innerHTML = '';
      layers = [];
      var seams = seamsFor(state.count);
      var band = bandFor(state.count);
      for (var i = 0; i < state.count; i++) {
        var layer = document.createElement('div');
        layer.className = 'sp-cust__layer';
        layer.setAttribute('data-sp-layer', String(i));

        // Layer 0 is the base: unmasked, and the sole source of the chain,
        // background and drop shadow.
        var host = layer;
        if (i > 0) {
          var seam = seams[i - 1];
          setMask(layer, 'linear-gradient(to right, transparent ' +
            (seam - FEATHER).toFixed(2) + '%, #000 ' + (seam + FEATHER).toFixed(2) + '%)');

          var bandEl = document.createElement('div');
          bandEl.className = 'sp-cust__layer__band';
          if (band) {
            setMask(bandEl, 'linear-gradient(to bottom, transparent ' +
              (band.top - BAND_FEATHER).toFixed(2) + '%, #000 ' +
              (band.top + BAND_FEATHER).toFixed(2) + '%, #000 ' +
              (band.bottom - BAND_FEATHER).toFixed(2) + '%, transparent ' +
              (band.bottom + BAND_FEATHER).toFixed(2) + '%)');
          }
          layer.appendChild(bandEl);
          host = bandEl;
        }

        var a = document.createElement('img');
        a.className = 'sp-cust__layer__img is-active';
        a.alt = '';
        a.setAttribute('aria-hidden', 'true');
        var b = document.createElement('img');
        b.className = 'sp-cust__layer__img';
        b.alt = '';
        b.setAttribute('aria-hidden', 'true');
        host.appendChild(a);
        host.appendChild(b);
        refs.composite.appendChild(layer);
        layers.push({ el: layer, imgs: [a, b], shown: 0, month: null });
        watchImg(a); watchImg(b);
      }
    }

    function watchImg(img) {
      if (img.dataset.spDiag === '1') return;
      img.dataset.spDiag = '1';
      img.addEventListener('error', function () {
        try { console.warn('[sweet-pea-customiser] Render failed to load:', img.currentSrc || img.src); } catch (e) {}
      });
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Preload a render, falling back to the untransformed original if the
    // resized variant 404s.
    //
    // Some files in Shopify Files serve their original fine but reject every
    // resize transform (?width=, ?height=, _900x.png — all 404). Without this
    // fallback those positions render as a broken image. The fallback keeps the
    // bracelet correct at the cost of a much larger download, so the real fix
    // is to re-upload the affected files — see the note in the section header.
    function loadRender(url, fallbackUrl, onOk, onFail) {
      var im = new Image();
      im.onload = function () { onOk(url); };
      im.onerror = function () {
        if (fallbackUrl && fallbackUrl !== url) {
          try {
            console.warn('[sweet-pea-customiser] Resize transform unavailable, ' +
                         'retrying the full-size original:', url);
          } catch (e) {}
          loadRender(fallbackUrl, null, onOk, onFail);
          return;
        }
        try { console.warn('[sweet-pea-customiser] Render unavailable:', url); } catch (e) {}
        if (onFail) onFail(url);
      };
      im.src = url;
    }

    // Never ship a silently broken preview.
    //
    // Keyed per individual render (metal + count + month), and by the config
    // the failed request was issued for rather than whatever is on screen when
    // a slow 404 finally returns. Per-month matters because only some months
    // are affected — keying by metal+count alone would blank a preview that
    // would have drawn perfectly.
    var renderFailures = {};
    function failKey(metal, count, month) { return metal + ':' + count + ':' + month; }

    function noteRenderFailure(metal, count, month) {
      renderFailures[failKey(metal, count, month)] = true;
      renderPreviewNote();
    }

    // True when any position currently on show needs a render we know we can't
    // fetch.
    function currentHasFailure() {
      for (var i = 0; i < state.count; i++) {
        var m = state.stones[i] || PLACEHOLDER;
        if (renderFailures[failKey(state.metal, state.count, m)]) return true;
      }
      return false;
    }

    // A partial composite is worse than none. Layers are masked strips, so if
    // the base fails while an overlay paints, the customer sees a fragment of a
    // bracelet floating in space. Blank the whole stack and explain instead.
    // The aspect-ratio box stays, so nothing reflows.
    function renderPreviewNote() {
      var broken = currentHasFailure();
      refs.previewNote.hidden = !broken;
      refs.composite.classList.toggle('is-unavailable', broken);
      if (broken) {
        refs.previewNote.textContent =
          'We can’t show a preview of this exact combination right now. ' +
          'Your choices are saved, and your bracelet will be made exactly as selected.';
      }
    }

    function paintLayer(i, month) {
      var layer = layers[i];
      if (!layer) return;
      if (layer.month === month) return;
      // Capture the config this request belongs to, so a late failure is
      // attributed correctly even if the customer has moved on since.
      var reqMetal = state.metal;
      var reqCount = state.count;
      var sized = renderUrl(month, reqCount, reqMetal, 900);
      var original = renderUrl(month, reqCount, reqMetal, 0);
      if (!sized) return;

      // Straight swap on first paint and under prefers-reduced-motion;
      // crossfade otherwise.
      var instant = (layer.month === null || reduceMotion);
      var cur = layer.imgs[layer.shown];
      var next = layer.imgs[1 - layer.shown];

      // Token guards against out-of-order loads: if the customer changes this
      // position again before the first render arrives, the stale load must
      // not win.
      var token = (layer.token || 0) + 1;
      layer.token = token;
      layer.month = month;

      loadRender(sized, original, function (okUrl) {
        if (layer.token !== token) return;
        if (instant) { cur.src = okUrl; return; }
        // Commit in the same tick — loadRender has already fetched this exact
        // URL, so assigning it to a visible <img> paints from cache well inside
        // the 150ms fade. Deliberately NOT gated on requestAnimationFrame or
        // decode(): neither resolves while the tab is backgrounded, which would
        // strand the preview showing the previous stone.
        next.src = okUrl;
        next.classList.add('is-active');
        cur.classList.remove('is-active');
        layer.shown = 1 - layer.shown;
      }, function () { noteRenderFailure(reqMetal, reqCount, month); });
    }

    function renderPreview() {
      for (var i = 0; i < state.count; i++) {
        paintLayer(i, state.stones[i] || PLACEHOLDER);
      }
      var chosen = state.stones.filter(Boolean);
      var alt;
      if (chosen.length === state.count) {
        alt = state.count + '-stone SWEET PEA birthstone bracelet in ' + state.metal +
              ', with ' + state.stones.map(function (m, i) {
                return 'position ' + (i + 1) + ' ' + label(m);
              }).join(', ');
      } else {
        alt = state.count + '-stone SWEET PEA birthstone bracelet in ' + state.metal +
              ', ' + chosen.length + ' of ' + state.count + ' stones chosen';
      }
      refs.composite.setAttribute('aria-label', alt);
    }

    // --- Controls ------------------------------------------------------------

    function buildSegments() {
      refs.metalGroup.innerHTML = '';
      ['gold', 'silver'].forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp-cust__segment';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-sp-metal', m);
        b.innerHTML = '<span class="sp-cust__segment__dot sp-cust__segment__dot--' + m + '" aria-hidden="true"></span>' +
                      '<span>' + (m === 'gold' ? 'Gold' : 'Silver') + '</span>';
        refs.metalGroup.appendChild(b);
      });

      refs.countGroup.innerHTML = '';
      COUNTS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp-cust__segment';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-sp-count', String(c));
        b.textContent = String(c);
        b.setAttribute('aria-label', c + ' stones');
        refs.countGroup.appendChild(b);
      });
    }

    function renderSegments() {
      $$('[data-sp-metal]', refs.metalGroup).forEach(function (b) {
        var m = b.getAttribute('data-sp-metal');
        var on = m === state.metal;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        var v = findVariant(m, state.count);
        b.disabled = !!(v && !v.available);
      });
      $$('[data-sp-count]', refs.countGroup).forEach(function (b) {
        var c = parseInt(b.getAttribute('data-sp-count'), 10);
        var on = c === state.count;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        var v = findVariant(state.metal, c);
        b.disabled = !!(v && !v.available);
      });
    }

    // --- Slots ---------------------------------------------------------------

    function renderSlots() {
      // This rebuilds the whole list, which destroys whatever had focus. Note
      // what was focused so it can be restored afterwards — otherwise choosing,
      // removing or reordering with the keyboard drops focus to <body> and a
      // keyboard-only customer loses their place.
      var focusKey = null;
      var ae = document.activeElement;
      if (ae && refs.slots.contains(ae)) {
        if (ae.hasAttribute('data-sp-slot-btn')) {
          focusKey = { i: parseInt(ae.getAttribute('data-sp-slot-btn'), 10) };
        }
      }

      refs.slots.innerHTML = '';
      for (var i = 0; i < state.count; i++) {
        var month = state.stones[i] || null;
        var li = document.createElement('li');
        li.className = 'sp-cust__slot' + (month ? ' sp-cust__slot--filled' : '') +
                       (i === state.active ? ' sp-cust__slot--active' : '');
        li.setAttribute('data-sp-slot', String(i));
        li.draggable = true;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sp-cust__slot__btn';
        btn.setAttribute('data-sp-slot-btn', String(i));
        btn.setAttribute('aria-pressed', i === state.active ? 'true' : 'false');
        btn.setAttribute('aria-label', month
          ? 'Position ' + (i + 1) + ' of ' + state.count + ', ' + label(month) + '. Select to change.'
          : 'Position ' + (i + 1) + ' of ' + state.count + ', no stone chosen. Select to choose.');
        if (month) {
          var im = document.createElement('img');
          im.className = 'sp-cust__slot__img';
          im.src = withWidth(SWATCHES[month], 180);
          im.alt = '';
          im.loading = 'lazy';
          btn.appendChild(im);
        } else {
          var plus = document.createElement('span');
          plus.className = 'sp-cust__slot__empty';
          plus.textContent = '+';
          plus.setAttribute('aria-hidden', 'true');
          btn.appendChild(plus);
        }
        li.appendChild(btn);

        var pos = document.createElement('span');
        pos.className = 'sp-cust__slot__pos';
        pos.textContent = String(i + 1);
        li.appendChild(pos);

        refs.slots.appendChild(li);
      }

      if (focusKey) {
        var fi = Math.max(0, Math.min(state.count - 1, focusKey.i));
        var target = refs.slots.querySelector('[data-sp-slot-btn="' + fi + '"]');
        if (target) target.focus();
      }
    }

    // --- Swatch grid ---------------------------------------------------------

    function buildGrid() {
      var frag = document.createDocumentFragment();
      STONES.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sp-cust__swatch';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-label', s.monthLabel + ' — ' + s.stone);
        btn.setAttribute('data-sp-swatch', s.month);
        btn.setAttribute('tabindex', '-1');
        btn.innerHTML =
          '<img class="sp-cust__swatch__img" src="' + withWidth(SWATCHES[s.month], 180) +
          '" alt="" loading="lazy" width="80" height="80">' +
          '<span class="sp-cust__swatch__label">' + s.monthLabel + '</span>' +
          '<span class="sp-cust__swatch__stone">' + s.stone + '</span>';
        frag.appendChild(btn);
      });
      refs.grid.appendChild(frag);
    }

    function renderGrid() {
      var current = state.stones[state.active] || null;
      $$('[data-sp-swatch]', refs.grid).forEach(function (b, i) {
        var on = b.getAttribute('data-sp-swatch') === current;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : (current === null && i === 0 ? '0' : '-1'));
      });
    }

    // --- Cart properties -----------------------------------------------------

    var SESSION_ID = uid();
    var propsFrag = ROOT.querySelector('[data-sp-tpl="properties"]').content.cloneNode(true);
    var staticProps = {};
    Array.prototype.forEach.call(propsFrag.querySelectorAll('[data-sp-prop]'), function (el) {
      staticProps[el.getAttribute('data-sp-prop')] = el;
    });
    staticProps['_SP Session ID'].value = SESSION_ID;
    form.appendChild(propsFrag);

    // Birthstone 1..N are created and destroyed as the count changes, so a
    // reduced count can never leave a stale "Birthstone 5" on the line item.
    var birthstoneInputs = [];
    function syncProperties() {
      while (birthstoneInputs.length > state.count) {
        var gone = birthstoneInputs.pop();
        if (gone.parentNode) gone.parentNode.removeChild(gone);
      }
      while (birthstoneInputs.length < state.count) {
        var idx = birthstoneInputs.length + 1;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Birthstone ' + idx + ']';
        form.appendChild(input);
        birthstoneInputs.push(input);
      }
      for (var i = 0; i < state.count; i++) {
        birthstoneInputs[i].value = state.stones[i] ? label(state.stones[i]) : '';
      }
      staticProps['_stone_codes'].value = state.stones
        .slice(0, state.count)
        .map(function (m) { return m ? m.toUpperCase() : ''; })
        .join('|');
      staticProps['_render_layers'].value = state.stones
        .slice(0, state.count)
        .map(function (m) { return m ? renderFilename(m) : ''; })
        .join('|');
    }

    // Persist the configuration so a future cart-image snippet can rebuild the
    // composite for the cart line, mirroring the Toi & Moi approach.
    function storeCompositeMeta() {
      try {
        var raw = JSON.parse(localStorage.getItem('sp_composites') || '{}');
        raw[SESSION_ID] = { metal: state.metal, count: state.count, stones: state.stones.slice(0, state.count) };
        var keys = Object.keys(raw);
        if (keys.length > 16) {
          var trimmed = {};
          keys.slice(-16).forEach(function (k) { trimmed[k] = raw[k]; });
          raw = trimmed;
        }
        localStorage.setItem('sp_composites', JSON.stringify(raw));
      } catch (e) {}
    }

    // --- Validation / ATC gating --------------------------------------------

    function isComplete() {
      if (state.stones.length < state.count) return false;
      for (var i = 0; i < state.count; i++) if (!state.stones[i]) return false;
      return true;
    }

    function renderNotice() {
      var complete = isComplete();
      if (complete) {
        refs.notice.textContent = '';
        refs.notice.classList.remove('sp-cust__notice--warn');
      } else {
        var missing = 0;
        for (var i = 0; i < state.count; i++) if (!state.stones[i]) missing++;
        refs.notice.textContent = 'Choose a stone for each position — ' + missing +
          (missing === 1 ? ' position still needs one.' : ' positions still need one.');
        refs.notice.classList.add('sp-cust__notice--warn');
      }
      ROOT._spCanSubmit = complete;

      var filled = 0;
      for (var j = 0; j < state.count; j++) if (state.stones[j]) filled++;
      var ratio = filled + '/' + state.count;
      if (refs.pillCounter) refs.pillCounter.textContent = ratio;
      if (refs.drawerTitleCounter) refs.drawerTitleCounter.textContent = ratio;
      if (refs.drawerCtaCounter) refs.drawerCtaCounter.textContent = ratio;
      if (refs.drawerConfirm) refs.drawerConfirm.disabled = !complete;

      // Reflect the blocked state on the theme's add-to-cart button. Marked
      // aria-disabled rather than disabled: a real `disabled` button swallows
      // the click, and the click is how the customer gets told WHY it's
      // blocked (we jump them to the first empty position).
      if (refs.atcBtn) {
        refs.atcBtn.setAttribute('aria-disabled', complete ? 'false' : 'true');
        refs.atcBtn.classList.toggle('sp-cust-atc-blocked', !complete);
        if (refs.notice.id) refs.atcBtn.setAttribute('aria-describedby', refs.notice.id);
      }
    }

    function blockSubmit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var firstEmpty = 0;
      for (var i = 0; i < state.count; i++) { if (!state.stones[i]) { firstEmpty = i; break; } }
      setActive(firstEmpty);
      // The slots live in the drawer now, so open it rather than trying to
      // scroll to a row that isn't on the page.
      openDrawer();
      announce('Choose a stone for each position before adding to cart.');
    }

    function handleAtcEvent(e) {
      if (e.type === 'click' && !e.target.closest('[data-add-to-cart]')) return;
      if (!ROOT._spCanSubmit) { blockSubmit(e); return; }
      storeCompositeMeta();
    }
    form.addEventListener('click', handleAtcEvent, true);
    form.addEventListener('submit', handleAtcEvent, true);

    // --- URL state -----------------------------------------------------------
    // The picker's configuration lives in query params so a customer can share
    // or return to their bracelet and we can link to pre-built combinations.
    // Shopify's own ?variant= is left to the theme.

    var restoring = false;
    function writeUrl(replace) {
      if (restoring) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sp_metal', state.metal);
        url.searchParams.set('sp_count', String(state.count));
        var chosen = state.stones.slice(0, state.count).map(function (m) { return m || ''; });
        if (chosen.some(Boolean)) url.searchParams.set('sp_stones', chosen.join('.'));
        else url.searchParams.delete('sp_stones');
        history[replace ? 'replaceState' : 'pushState']({ sp: true }, '', url.toString());
      } catch (e) {}
    }

    function readUrl() {
      try {
        var p = new URL(window.location.href).searchParams;
        var metal = p.get('sp_metal');
        var count = parseInt(p.get('sp_count'), 10);
        var stones = p.get('sp_stones');
        var changed = false;
        if (metal === 'gold' || metal === 'silver') { state.metal = metal; changed = true; }
        if (COUNTS.indexOf(count) !== -1) { state.count = count; changed = true; }
        if (stones !== null) {
          var parts = stones.split('.');
          var next = [];
          for (var i = 0; i < state.count; i++) {
            var m = parts[i];
            next.push(m && stoneByMonth(m) ? m : null);
          }
          state.stones = next;
          changed = true;
        }
        return changed;
      } catch (e) { return false; }
    }

    window.addEventListener('popstate', function () {
      restoring = true;
      readUrl();
      state.active = firstEmptyIndex();
      buildLayers();
      renderAll();
      restoring = false;
    });

    // --- Undo (for a destructive count decrease) -----------------------------

    var undoSnapshot = null;
    var undoTimer = null;

    function offerUndo(message, snapshot) {
      undoSnapshot = snapshot;
      refs.undoText.textContent = message;
      refs.undo.hidden = false;
      if (undoTimer) clearTimeout(undoTimer);
      undoTimer = setTimeout(hideUndo, 10000);
    }
    function hideUndo() {
      refs.undo.hidden = true;
      undoSnapshot = null;
      if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
    }
    refs.undoBtn.addEventListener('click', function () {
      if (!undoSnapshot) return;
      state.metal = undoSnapshot.metal;
      state.count = undoSnapshot.count;
      state.stones = undoSnapshot.stones.slice();
      state.active = firstEmptyIndex();
      hideUndo();
      applyVariant();
      buildLayers();
      renderAll();
      writeUrl(false);
      announce('Change undone.');
    });

    // --- Mutations -----------------------------------------------------------

    function firstEmptyIndex() {
      for (var i = 0; i < state.count; i++) if (!state.stones[i]) return i;
      return Math.max(0, state.count - 1);
    }

    function setActive(i) {
      state.active = Math.max(0, Math.min(state.count - 1, i));
      renderSlots();
      renderGrid();
    }

    function setMetal(metal) {
      if (metal === state.metal) return;
      state.metal = metal;
      applyVariant();
      // Layers keep their masks — only the source metal changes, so invalidate
      // the cached month per layer and let renderAll repaint them.
      for (var i = 0; i < layers.length; i++) layers[i].month = null;
      renderAll();
      writeUrl(false);
      storeCompositeMeta();
      track('metal_changed', { product: 'sweet_pea', metal: metal });
      announce(metal === 'gold' ? 'Gold selected.' : 'Silver selected.');
    }

    function setCount(count) {
      if (count === state.count) return;
      var prev = { metal: state.metal, count: state.count, stones: state.stones.slice() };
      var losing = null;

      if (count < state.count) {
        // Removing from the end: warn only if the dropped slots held stones.
        var dropped = state.stones.slice(count, state.count).filter(Boolean);
        if (dropped.length) losing = dropped;
        state.stones = state.stones.slice(0, count);
      } else {
        // Growing: append empty slots, leave existing choices untouched.
        while (state.stones.length < count) state.stones.push(null);
      }

      state.count = count;
      state.active = firstEmptyIndex();
      applyVariant();
      buildLayers();
      renderAll();
      writeUrl(false);
      storeCompositeMeta();

      if (losing) {
        offerUndo(
          losing.length === 1
            ? 'Removed ' + label(losing[0]) + ' from the last position.'
            : 'Removed ' + losing.length + ' stones from the end.',
          prev
        );
      } else {
        hideUndo();
      }
      track('count_changed', { product: 'sweet_pea', count: count });
      announce(count + ' stones selected.');
    }

    function setStone(index, month) {
      state.stones[index] = month;
      // Auto-advance to the next empty slot so a customer filling a 5-stone
      // bracelet never has to click back into the slot row.
      var next = -1;
      for (var i = 0; i < state.count; i++) if (!state.stones[i]) { next = i; break; }
      state.active = next === -1 ? index : next;
      renderAll();
      writeUrl(false);
      storeCompositeMeta();
      track('birthstone_selected', {
        product: 'sweet_pea',
        month: month,
        stone_name: (stoneByMonth(month) || {}).stone,
        position: index + 1
      });
      announce(label(month) + ' set for position ' + (index + 1) + '.');
    }

    function clearStone(index) {
      if (!state.stones[index]) return;
      var was = state.stones[index];
      state.stones[index] = null;
      state.active = index;
      renderAll();
      writeUrl(false);
      storeCompositeMeta();
      announce(label(was) + ' removed from position ' + (index + 1) + '.');
    }

    function moveStone(from, to) {
      if (to < 0 || to >= state.count || from === to) return;
      var arr = state.stones.slice(0, state.count);
      var moved = arr.splice(from, 1)[0];
      arr.splice(to, 0, moved);
      state.stones = arr;
      state.active = to;
      renderAll();
      writeUrl(false);
      storeCompositeMeta();
      track('stones_reordered', { product: 'sweet_pea', from: from + 1, to: to + 1 });
      announce('Moved to position ' + (to + 1) + '.');
      // Keep focus on the slot the customer is moving.
      var btn = refs.slots.querySelector('[data-sp-slot-btn="' + to + '"]');
      if (btn) btn.focus();
    }

    function resetAll() {
      state.stones = [];
      for (var i = 0; i < state.count; i++) state.stones.push(null);
      state.active = 0;
      hideUndo();
      renderAll();
      writeUrl(false);
      storeCompositeMeta();
      announce('Selections cleared.');
    }

    function renderAll() {
      renderSegments();
      renderSlots();
      renderGrid();
      renderPreview();
      renderPreviewNote();
      syncProperties();
      renderNotice();
    }

    // --- Events --------------------------------------------------------------

    refs.metalGroup.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sp-metal]');
      if (b && !b.disabled) setMetal(b.getAttribute('data-sp-metal'));
    });
    refs.countGroup.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sp-count]');
      if (b && !b.disabled) setCount(parseInt(b.getAttribute('data-sp-count'), 10));
    });

    // Arrow-key roving focus within each segmented radiogroup.
    function segmentKeys(group, attr) {
      group.addEventListener('keydown', function (e) {
        var b = e.target.closest('[' + attr + ']');
        if (!b) return;
        var items = $$('[' + attr + ']', group).filter(function (n) { return !n.disabled; });
        var idx = items.indexOf(b);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = items[(idx + 1) % items.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = items[(idx - 1 + items.length) % items.length];
        else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); b.click(); return; }
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    }
    segmentKeys(refs.metalGroup, 'data-sp-metal');
    segmentKeys(refs.countGroup, 'data-sp-count');

    refs.slots.addEventListener('click', function (e) {
      var slotBtn = e.target.closest('[data-sp-slot-btn]');
      if (slotBtn) setActive(parseInt(slotBtn.getAttribute('data-sp-slot-btn'), 10));
    });

    // Keyboard: arrows move focus between slots; Alt+arrows reorder (the
    // visible arrow buttons are the pointer equivalent).
    refs.slots.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-sp-slot-btn]');
      if (!btn) return;
      var i = parseInt(btn.getAttribute('data-sp-slot-btn'), 10);
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        var dir = e.key === 'ArrowRight' ? 1 : -1;
        if (e.altKey) { moveStone(i, i + dir); return; }
        var ni = i + dir;
        if (ni < 0 || ni >= state.count) return;
        // setActive re-renders the slot list, so the button must be re-queried
        // afterwards — focusing the pre-render node would silently do nothing
        // and drop focus to <body>.
        setActive(ni);
        var target = refs.slots.querySelector('[data-sp-slot-btn="' + ni + '"]');
        if (target) target.focus();
      } else if (e.key === 'Delete' || e.key === 'Backspace') {
        e.preventDefault();
        clearStone(i);
      }
    });

    // Drag and drop reordering (desktop pointer equivalent of the arrows).
    var dragIndex = null;
    refs.slots.addEventListener('dragstart', function (e) {
      var li = e.target.closest('[data-sp-slot]');
      if (!li) return;
      dragIndex = parseInt(li.getAttribute('data-sp-slot'), 10);
      li.classList.add('is-dragging');
      try {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(dragIndex));
      } catch (err) {}
    });
    refs.slots.addEventListener('dragover', function (e) {
      if (dragIndex === null) return;
      e.preventDefault();
      try { e.dataTransfer.dropEffect = 'move'; } catch (err) {}
      var li = e.target.closest('[data-sp-slot]');
      $$('[data-sp-slot]', refs.slots).forEach(function (n) { n.classList.remove('is-drop-target'); });
      if (li) li.classList.add('is-drop-target');
    });
    refs.slots.addEventListener('drop', function (e) {
      if (dragIndex === null) return;
      e.preventDefault();
      var li = e.target.closest('[data-sp-slot]');
      if (li) moveStone(dragIndex, parseInt(li.getAttribute('data-sp-slot'), 10));
      dragIndex = null;
    });
    refs.slots.addEventListener('dragend', function () {
      dragIndex = null;
      $$('[data-sp-slot]', refs.slots).forEach(function (n) {
        n.classList.remove('is-drop-target');
        n.classList.remove('is-dragging');
      });
    });

    refs.grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sp-swatch]');
      if (!b) return;
      prefetchAllMonths();
      setStone(state.active, b.getAttribute('data-sp-swatch'));
    });

    refs.grid.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-sp-swatch]');
      if (!b) return;
      var items = $$('[data-sp-swatch]', refs.grid);
      var idx = items.indexOf(b);
      var cols = 4; // must match .sp-cust__grid's column count
      var next = null;
      if (e.key === 'ArrowRight') next = items[(idx + 1) % items.length];
      else if (e.key === 'ArrowLeft') next = items[(idx - 1 + items.length) % items.length];
      else if (e.key === 'ArrowDown') next = items[(idx + cols) % items.length];
      else if (e.key === 'ArrowUp') next = items[(idx - cols + items.length) % items.length];
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); b.click(); return; }
      if (next) { e.preventDefault(); next.focus(); }
    });

    // --- Drawer open / close -------------------------------------------------

    var triggerEl = null;

    function openDrawer() {
      if (refs.drawer.classList.contains('is-open')) return;
      triggerEl = document.activeElement;
      refs.backdrop.classList.add('is-open');
      refs.drawer.classList.add('is-open');
      document.documentElement.classList.add('sp-cust-locked');
      document.body.classList.add('sp-cust-locked');
      setTimeout(function () { refs.drawerClose.focus(); }, 50);
      prefetchAllMonths();
      track('gemstone_drawer_opened', { product: 'sweet_pea' });
    }

    function closeDrawer() {
      refs.backdrop.classList.remove('is-open');
      refs.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('sp-cust-locked');
      document.body.classList.remove('sp-cust-locked');
      if (triggerEl && typeof triggerEl.focus === 'function') {
        try { triggerEl.focus(); } catch (e) {}
      }
    }

    refs.pillBtn.addEventListener('click', openDrawer);
    refs.drawerClose.addEventListener('click', closeDrawer);
    refs.backdrop.addEventListener('click', closeDrawer);
    refs.drawerConfirm.addEventListener('click', function () {
      if (refs.drawerConfirm.disabled) return;
      closeDrawer();
      track('gemstones_confirmed', {
        product: 'sweet_pea',
        metal: state.metal,
        count: state.count,
        stones: state.stones.slice(0, state.count).join('|')
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && refs.drawer.classList.contains('is-open')) {
        e.stopPropagation();
        closeDrawer();
      }
    });

    // Focus trap
    refs.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', refs.drawer)
        .filter(function (n) { return !n.hasAttribute('disabled') && n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Swipe down to dismiss on mobile, matching the Toi & Moi drawer.
    (function () {
      var startY = null;
      refs.drawer.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 768) return;
        if (refs.drawerBody.scrollTop > 0) return;
        startY = e.touches[0].clientY;
      }, { passive: true });
      refs.drawer.addEventListener('touchmove', function (e) {
        if (startY == null) return;
        if (e.touches[0].clientY - startY > 80) { closeDrawer(); startY = null; }
      }, { passive: true });
      refs.drawer.addEventListener('touchend', function () { startY = null; }, { passive: true });
    })();

    refs.reset.addEventListener('click', resetAll);

    // Mirror variant changes made through the theme's own selectors back into
    // the picker, so the two controls can never disagree.
    document.addEventListener('theme:variant:change', function (e) {
      if (suppressVariantEcho) return;
      var v = e && e.detail && e.detail.variant;
      if (!v) return;
      for (var i = 0; i < VARIANTS.length; i++) {
        if (VARIANTS[i].id === v.id) {
          var changed = false;
          if (VARIANTS[i].metal !== state.metal) { state.metal = VARIANTS[i].metal; changed = true; }
          if (VARIANTS[i].count !== state.count) {
            setCount(VARIANTS[i].count);
            return;
          }
          if (changed) {
            for (var j = 0; j < layers.length; j++) layers[j].month = null;
            renderAll();
            writeUrl(true);
          }
          return;
        }
      }
    });

    // --- Prefetch ------------------------------------------------------------
    // Warm the current count+metal so swapping a stone is instant; everything
    // else stays lazy.
    var prefetched = {};
    function prefetchAllMonths() {
      var key = state.metal + ':' + state.count;
      if (prefetched[key]) return;
      prefetched[key] = true;
      STONES.forEach(function (s) {
        var im = new Image();
        im.src = renderUrl(s.month, state.count, state.metal, 900);
      });
    }

    // --- Misc ----------------------------------------------------------------

    function track(name, params) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          var p = { event: name };
          for (var k in params) if (params.hasOwnProperty(k)) p[k] = params[k];
          window.dataLayer.push(p);
        }
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent('sp:' + name, { bubbles: true, detail: params || {} }));
      } catch (e) {}
    }

    function announce(msg) {
      if (!refs.srAnnounce) return;
      refs.srAnnounce.textContent = '';
      setTimeout(function () { refs.srAnnounce.textContent = msg; }, 30);
    }

    // --- First paint ---------------------------------------------------------

    buildSegments();
    buildGrid();

    for (var i0 = 0; i0 < state.count; i0++) state.stones.push(null);
    readUrl();
    while (state.stones.length < state.count) state.stones.push(null);
    state.stones = state.stones.slice(0, state.count);
    // No-op when the picker and the theme's selectors already agree (the usual
    // case, since initial metal/count are read off the selected variant); it
    // only does work when a ?sp_ deep link asked for something else.
    applyVariant();
    state.active = firstEmptyIndex();

    buildLayers();
    renderAll();
    writeUrl(true);
    storeCompositeMeta();

    // Warm the current combination once the page is idle.
    if (window.requestIdleCallback) window.requestIdleCallback(prefetchAllMonths);
    else setTimeout(prefetchAllMonths, 1500);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toi-moi-customiser"]) return;
  try {
    
  (function () {
    'use strict';

    var ROOT = document.querySelector('[data-tm-cust]');
    if (!ROOT) return;

    var configEl = ROOT.querySelector('[data-tm-config]');
    if (!configEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }

    var STONES = CONFIG.stones;
    var RINGS_BY_METAL = CONFIG.rings;
    var EMERALD_SWATCHES = CONFIG.emeraldSwatches;
    var PEAR_SWATCHES = CONFIG.pearSwatches;
    var SEAM_BY_METAL = CONFIG.seamByMetal || { gold: 0.50, silver: 0.50, rose_gold: 0.50 };

    // Default state per brief: March (Aquamarine, emerald cut) left + September (Sapphire, pear cut) right
    var DEFAULT_LEFT = 'march';
    var DEFAULT_RIGHT = 'september';
    var VALID_METALS = ['gold', 'silver', 'rose_gold'];

    var currentMetal = (CONFIG.initialMetal && RINGS_BY_METAL[CONFIG.initialMetal]) ? CONFIG.initialMetal : 'gold';

    function normaliseMetal(v) {
      if (!v) return null;
      var m = String(v).trim().toLowerCase().replace(/\s+/g, '_');
      if (m === 'rose_gold' || m === 'silver' || m === 'gold') return m;
      if (m === 'yellow_gold') return 'gold';
      if (m === 'white_gold')  return 'silver';
      return null;
    }

    function detectMetalFromVariant(variant) {
      if (!variant || !variant.options) return null;
      for (var i = 0; i < variant.options.length; i++) {
        var n = normaliseMetal(variant.options[i]);
        if (n) return n;
      }
      return null;
    }

    function getSeam(metal) {
      var s = SEAM_BY_METAL[metal];
      return (typeof s === 'number') ? s : 0.50;
    }

    function ringUrl(month, w, metalOverride) {
      var metal = metalOverride || currentMetal;
      var bucket = RINGS_BY_METAL[metal] || RINGS_BY_METAL.gold;
      var u = bucket && bucket[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 900) : '';
    }
    function emeraldSwatchUrl(month, w) {
      var u = EMERALD_SWATCHES[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 180) : '';
    }
    function pearSwatchUrl(month, w) {
      var u = PEAR_SWATCHES[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 180) : '';
    }
    function stoneByMonth(m) {
      for (var i = 0; i < STONES.length; i++) if (STONES[i].month === m) return STONES[i];
      return null;
    }
    function stoneName(m) { var s = stoneByMonth(m); return s ? s.stone : ''; }
    function labelFor(month, cut) {
      // e.g. "Aquamarine (March) — Emerald cut"
      var s = stoneByMonth(month);
      if (!s) return '';
      return s.stone + ' (' + s.monthLabel + ') — ' + cut + ' cut';
    }
    function uid() {
      return 'tm-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // --- Mount: clone templates into their final locations ---------------------

    function tpl(name) {
      var t = ROOT.querySelector('[data-tm-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : null;
    }

    var pillsFrag = tpl('pills');
    var drawerFrag = tpl('drawer');
    var propsFrag = tpl('properties');
    if (!pillsFrag || !drawerFrag || !propsFrag) return;

    // 1) Inject hidden line-item-property inputs into the product form
    var form = document.querySelector('form[action*="/cart/add"][data-product-form]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var SESSION_ID = uid();
    var propInputs = {};
    Array.prototype.forEach.call(propsFrag.querySelectorAll('[data-tm-prop]'), function (el) {
      propInputs[el.getAttribute('data-tm-prop')] = el;
    });
    propInputs['_TM Session ID'].value = SESSION_ID;
    form.appendChild(propsFrag);

    // 2) Move pills into the form, BELOW the size selector (mirrors Love Knot anchor strategy)
    var pillsHost = document.createElement('div');
    pillsHost.className = 'tm-cust tm-cust--pills-host';
    pillsHost.appendChild(pillsFrag);

    var selectorsAnchor = form.querySelector('.product__selectors');
    if (selectorsAnchor) {
      selectorsAnchor.insertAdjacentElement('afterend', pillsHost);
    } else {
      var submit = form.querySelector('.product__submit__holder') || form.querySelector('[data-add-to-cart]');
      if (submit && submit.parentNode) {
        submit.parentNode.insertBefore(pillsHost, submit);
      } else {
        form.appendChild(pillsHost);
      }
    }

    // 3) Mount the composite overlay on ONE primary gallery slide, and hide
    //    every other variant featured_media slide. The customer sees a single
    //    hero image that updates to the selected metal as they change Color
    //    (gold → silver → rose gold). The grid layout would otherwise show
    //    three separate slides — one per variant — which is redundant.
    //
    //    Inside the primary slide we hide the bare original image (figure/
    //    picture/etc.) so only our composite is visible. The aspect-ratio
    //    spacer is kept so the slide doesn't collapse.
    function mountOverlayOnSlide(slide) {
      if (!slide || slide.dataset.tmOverlayMounted === '1') return;
      slide.dataset.tmOverlayMounted = '1';
      var slideMedia = slide.querySelector('.product-single__media') || slide;
      var computed = getComputedStyle(slideMedia);
      if (computed.position === 'static') slideMedia.style.position = 'relative';
      // Hide the bare image (figure / picture / lazy-image / deferred-media) so
      // only our composite is visible on this slide. NOTE: we deliberately do
      // NOT hide `.product-single__media-link` — that's the theme's zoom /
      // lightbox anchor; keeping it in the DOM means clicking the composite
      // still opens the zoom view (the composite sits on top with
      // `pointer-events: none`, so clicks pass through to the link).
      var hideSelectors = [
        'figure',
        'picture',
        '.lazy-image',
        'deferred-media',
        '.deferred-media',
        '[data-deferred-media]'
      ].join(', ');
      Array.prototype.forEach.call(slideMedia.querySelectorAll(hideSelectors), function (el) {
        el.style.display = 'none';
      });
      slide.classList.remove('media--hidden');
      var overlayClone = ROOT.querySelector('[data-tm-tpl="overlay"]').content.cloneNode(true);
      slideMedia.appendChild(overlayClone);
    }

    // Pick the first slide as the primary and mount the composite on it.
    //
    // Subtlety: slide 1 is the current variant's featured_image — which on
    // this product is often a lifestyle shot ("hand wearing the ring", etc.)
    // that the merchant wants the customer to see. If we just overlay the
    // composite on slide 1, the lifestyle shot is hidden behind the
    // composite. So before overlaying, we CLONE slide 1 and insert the
    // clone as slide 2. Result: composite renders as slide 1 (prominent
    // hero), the original lifestyle photo still appears as slide 2.
    var allSlides = Array.prototype.slice.call(document.querySelectorAll('[data-product-single-media-group] [data-product-slide]'));
    var primarySlide = allSlides[0] || null;
    if (primarySlide && !primarySlide.dataset.tmOverlayMounted) {
      // Clone slide 1 BEFORE mounting the composite so the clone preserves
      // the figure / zoom link / bare image. The original then gets the
      // composite overlay treatment (which hides its figure).
      var bareClone = primarySlide.cloneNode(true);
      // Avoid duplicate IDs and theme-JS confusion
      bareClone.removeAttribute('id');
      var origId = primarySlide.getAttribute('data-id') || 'x';
      var bareDataId = 'tm-bare-' + origId;
      bareClone.setAttribute('data-id', bareDataId);
      bareClone.removeAttribute('data-media-id');
      bareClone.dataset.tmBareClone = '1';
      // Prevent AOS animations from double-firing on the clone
      bareClone.removeAttribute('data-aos');
      bareClone.removeAttribute('data-aos-order');
      bareClone.removeAttribute('data-aos-anchor');
      // Don't inherit "is-selected" — clone is just one of the regular slides
      bareClone.classList.remove('is-selected');
      // In carousel mode (mobile), non-featured slides default to
      // .media--hidden; the gallery JS will toggle this when the slide is
      // selected. Adding it on the clone keeps mobile carousel behaviour
      // sensible (clone is shown only when navigated to).
      bareClone.classList.add('media--hidden');
      if (primarySlide.parentNode) {
        primarySlide.parentNode.insertBefore(bareClone, primarySlide.nextSibling);
      }

      // Also clone the matching thumbnail (if a thumb strip exists), so the
      // thumb count keeps aligned with the slide count and clicking thumb 2
      // navigates to slide 2 (the bare clone), thumb 3 → slide 3, etc.
      // Without this step, the original thumb 1 (data-id=origId) maps to
      // slide 1 (composite), and there is no thumb for the cloned slide at
      // all — the thumbs end up "one behind" the slides.
      var thumbsRoot = document.querySelector('[data-product-single-media-thumbs]')
        || document.getElementById('ProductThumbs');
      if (thumbsRoot) {
        var primaryThumb = thumbsRoot.querySelector('[data-id="' + origId + '"]');
        if (primaryThumb && !primaryThumb.dataset.tmThumbCloneInserted) {
          primaryThumb.dataset.tmThumbCloneInserted = '1';
          // 1. CLONE the original first (so the clone preserves the
          //    hand-wearing-ring / lifestyle preview image). Then insert it
          //    after the original — this becomes the thumb for slide 2.
          var bareThumb = primaryThumb.cloneNode(true);
          bareThumb.setAttribute('data-id', bareDataId);
          bareThumb.removeAttribute('data-thumbnail-id');
          bareThumb.dataset.tmBareThumb = '1';
          bareThumb.classList.remove('is-selected');
          bareThumb.classList.remove('current');
          if (primaryThumb.parentNode) {
            primaryThumb.parentNode.insertBefore(bareThumb, primaryThumb.nextSibling);
          }

          // 2. Now swap the ORIGINAL thumb 1's image to a static gold-ring
          //    preview — so the two thumbs are visually distinct. Thumb 1
          //    (gold ring) represents the composite slot, thumb 2 (lifestyle
          //    photo, just cloned above) represents the original photo.
          //    Uses the March gold render — clean, on-brand, matches the
          //    customiser's default emerald-cut stone (Aquamarine).
          var compositeThumbUrl = 'https://cdn.shopify.com/s/files/1/0599/8352/8111/files/MARCH-GOLD-TOI.png?v=1778065399';
          var thumbImg = primaryThumb.querySelector('img');
          if (thumbImg) {
            thumbImg.removeAttribute('srcset');
            thumbImg.removeAttribute('data-srcset');
            thumbImg.removeAttribute('data-src');
            thumbImg.src = compositeThumbUrl + '&width=180';
            thumbImg.style.objectFit = thumbImg.style.objectFit || 'cover';
          }
          var thumbPicture = primaryThumb.querySelector('picture');
          if (thumbPicture) {
            Array.prototype.forEach.call(thumbPicture.querySelectorAll('source'), function (s) {
              s.srcset = compositeThumbUrl + '&width=180';
              s.removeAttribute('data-srcset');
            });
          }
        }
      }
    }
    if (primarySlide) mountOverlayOnSlide(primarySlide);

    // 4) Mount the drawer + backdrop on <body>
    var drawerHost = document.createElement('div');
    drawerHost.className = 'tm-cust';
    drawerHost.appendChild(drawerFrag);
    document.body.appendChild(drawerHost);

    // --- DOM refs --------------------------------------------------------------

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    var refs = {
      pills: $('[data-tm="pills"]', pillsHost),
      gemPillBtn: $('[data-tm="open-drawer"]', pillsHost),
      gemPillCounter: $('[data-tm="gem-pill-counter"]', pillsHost),

      pdpComposites: [], pdpLefts: [], pdpRights: [],

      backdrop: $('[data-tm="backdrop"]', drawerHost),
      drawer: $('[data-tm="drawer"]', drawerHost),
      drawerClose: $('[data-tm="drawer-close"]', drawerHost),
      drawerComposite: $('[data-tm="drawer-composite"]', drawerHost),
      drawerLeft: $('[data-tm="drawer-left"]', drawerHost),
      drawerRight: $('[data-tm="drawer-right"]', drawerHost),
      drawerBody: $('[data-tm="drawer-body"]', drawerHost),
      sectionLeft: drawerHost.querySelector('[data-tm-section="left"] .tm-cust__grid'),
      sectionRight: drawerHost.querySelector('[data-tm-section="right"] .tm-cust__grid'),
      section2Heading: $('[data-tm="section-2-heading"]', drawerHost),
      drawerTitleCounter: $('[data-tm="drawer-title-counter"]', drawerHost),
      drawerCtaBtn: $('[data-tm="drawer-confirm"]', drawerHost),
      drawerCtaCounter: $('[data-tm="drawer-cta-counter"]', drawerHost),
      srAnnounce: $('[data-tm="sr-announce"]', drawerHost),

      atcBtn: form.querySelector('[data-add-to-cart]'),
      atcText: form.querySelector('[data-add-to-cart-text]')
    };

    if (!refs.atcBtn) return;
    var ORIGINAL_ATC_TEXT = refs.atcText ? refs.atcText.textContent : '';

    function refreshPdpRefs() {
      refs.pdpComposites = $$('[data-tm="pdp-composite"]');
      refs.pdpLefts      = $$('[data-tm="pdp-left"]');
      refs.pdpRights     = $$('[data-tm="pdp-right"]');
    }
    refreshPdpRefs();

    // --- Build swatch grids ----------------------------------------------------

    function buildGrid(container, position, swatchUrlFn, ariaCut) {
      var frag = document.createDocumentFragment();
      STONES.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tm-cust__swatch';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-label', s.monthLabel + ' — ' + s.stone + ' (' + ariaCut + ' cut)');
        btn.setAttribute('data-tm-swatch', s.month);
        btn.setAttribute('data-tm-position', position);
        btn.setAttribute('tabindex', '-1');
        btn.innerHTML =
          '<img class="tm-cust__swatch__img" src="' + swatchUrlFn(s.month, 180) + '" alt="" loading="lazy" width="80" height="80">' +
          '<span class="tm-cust__swatch__label">' + s.monthLabel + '</span>' +
          '<span class="tm-cust__swatch__stone">' + s.stone + '</span>';
        frag.appendChild(btn);
        // Log failed swatch URLs to console (e.g. wrong filename / CDN miss)
        var swatchImg = btn.querySelector('.tm-cust__swatch__img');
        if (swatchImg) {
          swatchImg.addEventListener('error', (function (url, month, cut) {
            return function () {
              try {
                console.warn('[toi-moi-customiser] Swatch failed to load:', cut, month, url);
              } catch (e) {}
            };
          })(swatchUrlFn(s.month, 180), s.month, ariaCut));
        }
      });
      container.appendChild(frag);
    }
    buildGrid(refs.sectionLeft,  'left',  emeraldSwatchUrl, 'emerald');
    buildGrid(refs.sectionRight, 'right', pearSwatchUrl,    'pear');

    // --- State -----------------------------------------------------------------

    var confirmed = { left: DEFAULT_LEFT, right: DEFAULT_RIGHT };
    var working   = { left: DEFAULT_LEFT, right: DEFAULT_RIGHT };
    var hasConfirmedOnce = false; // pill counter shows 0/2 until first Confirm

    var triggerEl = null; // for focus restore on close

    // --- Autoplay cycle (runs until customer first interacts) ------------------
    // Curated mixed-stone pairs that don't include the default — gives a glance
    // at variety without overshadowing the ad-creative default pairing.
    var AUTO_PAIRS = [
      ['october', 'june'],     // Pink Tourmaline + Alexandrite
      ['may', 'november'],     // Emerald + Citrine
      ['april', 'december'],   // Diamond + Tanzanite
      ['february', 'july']     // Amethyst + Ruby
    ];
    var AUTO_FRAME_MS = 1100;
    var AUTO_FIRST_DELAY_MS = 700;
    var autoTimer = null;
    var autoStartTimer = null;
    var autoStopped = false;
    var autoIdx = -1;

    function preloadCyclePairs() {
      var months = {};
      AUTO_PAIRS.forEach(function (p) { months[p[0]] = 1; months[p[1]] = 1; });
      Object.keys(months).forEach(function (m) {
        var im = new Image();
        im.src = ringUrl(m, 900);
      });
    }

    function startAutoplay() {
      if (autoStopped) return;
      preloadCyclePairs();
      autoStartTimer = setTimeout(function () {
        autoTimer = setInterval(autoTick, AUTO_FRAME_MS);
        autoTick();
      }, AUTO_FIRST_DELAY_MS);
    }

    function autoTick() {
      if (autoStopped) return;
      if (document.hidden) return;
      autoIdx = (autoIdx + 1) % AUTO_PAIRS.length;
      var p = AUTO_PAIRS[autoIdx];
      renderPdpRing(p[0], p[1]);
    }

    function stopAutoplay() {
      if (autoStopped) return;
      autoStopped = true;
      if (autoStartTimer) { clearTimeout(autoStartTimer); autoStartTimer = null; }
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      renderPdpRing(confirmed.left, confirmed.right);
    }

    // --- Renderers -------------------------------------------------------------

    function applySeamToComposite(compositeEl, metal) {
      if (!compositeEl) return;
      compositeEl.style.setProperty('--seam-pct', (getSeam(metal) * 100) + '%');
    }

    // Diagnostic: when a ring asset fails to load (404 / CDN error / typo in
    // brief), log the URL so it shows up in DevTools console. Without this,
    // a broken URL silently keeps the previous image visible — looking like
    // "this stone isn't updating" from the customer's perspective.
    // Attach once per <img>; the handler fires for any src that fails.
    function ensureImgErrorLogging(img) {
      if (!img || img.dataset.tmDiag === '1') return;
      img.dataset.tmDiag = '1';
      img.addEventListener('error', function () {
        try {
          var src = img.currentSrc || img.src || '(empty)';
          console.warn('[toi-moi-customiser] Ring asset failed to load:', src);
        } catch (e) {}
      });
    }

    // Render a single composite (PDP overlay or drawer preview).
    // Same-stone fast path: BOTH halves get the same source URL. The clip-path
    // halves overlap perfectly, producing a seamless single image with no
    // compositing artifact (browser caches the second image load — only one
    // network request).
    function renderComposite(compositeEl, leftImg, rightImg, left, right, metal, width) {
      if (!compositeEl) return;
      var m = metal || currentMetal;
      var w = width || 900;
      applySeamToComposite(compositeEl, m);
      ensureImgErrorLogging(leftImg);
      ensureImgErrorLogging(rightImg);
      var ls = stoneByMonth(left), rs = stoneByMonth(right);
      if (left === right) {
        var url = ringUrl(left, w, m);
        if (leftImg)  { leftImg.src  = url; if (ls) leftImg.alt  = ls.stone; }
        if (rightImg) { rightImg.src = url; if (ls) rightImg.alt = ls.stone; }
      } else {
        if (leftImg)  { leftImg.src  = ringUrl(left,  w, m); if (ls) leftImg.alt  = ls.stone; }
        if (rightImg) { rightImg.src = ringUrl(right, w, m); if (rs) rightImg.alt = rs.stone; }
      }
    }

    function renderPdpRing(left, right) {
      // Refresh refs in case overlays were stamped after init.
      // The PDP shows a single hero composite that always renders the
      // currently-selected metal — variant duplicate slides are hidden.
      refreshPdpRefs();
      for (var i = 0; i < refs.pdpComposites.length; i++) {
        renderComposite(
          refs.pdpComposites[i],
          refs.pdpLefts[i],
          refs.pdpRights[i],
          left, right,
          currentMetal,
          900
        );
      }
    }

    function renderDrawerPreview(left, right) {
      // Drawer preview always uses the customer's currently-selected metal —
      // it's previewing what THEY are configuring, not a per-slide thumbnail.
      // Use 600px assets — preview is at most ~240px wide.
      renderComposite(
        refs.drawerComposite,
        refs.drawerLeft,
        refs.drawerRight,
        left, right,
        currentMetal,
        600
      );
    }

    function renderSwatchSelected() {
      ['left', 'right'].forEach(function (pos) {
        var current = working[pos];
        $$('[data-tm-position="' + pos + '"]', drawerHost).forEach(function (b) {
          var checked = b.getAttribute('data-tm-swatch') === current;
          b.setAttribute('aria-checked', checked ? 'true' : 'false');
          b.setAttribute('tabindex', checked ? '0' : '-1');
        });
      });
    }

    function workingCount() {
      var n = 0; if (working.left) n++; if (working.right) n++; return n;
    }
    function confirmedCount() {
      if (!hasConfirmedOnce) return 0;
      var n = 0; if (confirmed.left) n++; if (confirmed.right) n++; return n;
    }

    function renderCounters() {
      var w = workingCount();
      var c = confirmedCount();
      refs.drawerTitleCounter.textContent = w + '/2';
      refs.drawerCtaCounter.textContent = w + '/2';
      refs.gemPillCounter.textContent = c + '/2';
      refs.drawerCtaBtn.disabled = (w < 2);
    }

    function renderAtcState() {
      // Conditions:
      //   1) size selected (or product has only default variant)
      //   2) both gemstones confirmed (default state pre-fills, but counter only
      //      shows 2/2 after first explicit Confirm)
      var sizeOk = isSizeSelected();
      var stonesOk = hasConfirmedOnce && !!(confirmed.left && confirmed.right);

      // Restore original ATC label (no engraving messaging on this product)
      if (refs.atcText) refs.atcText.textContent = ORIGINAL_ATC_TEXT;

      ROOT._tmCanSubmit = sizeOk && stonesOk;
    }

    function isSizeSelected() {
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return false;
      var v = idInput.value;
      if (!v) return false;
      // Each radio option group must have at least one checked radio.
      var groups = {};
      $$('.product__selectors input[type="radio"]', form).forEach(function (r) {
        groups[r.name] = groups[r.name] || { any: false };
        if (r.checked) groups[r.name].any = true;
      });
      for (var k in groups) if (groups.hasOwnProperty(k) && !groups[k].any) return false;
      return true;
    }

    // --- Drawer open/close -----------------------------------------------------

    var lastFocusable = null;
    var firstFocusable = null;

    function openDrawer() {
      stopAutoplay();

      working.left = confirmed.left;
      working.right = confirmed.right;
      renderDrawerPreview(working.left, working.right);
      renderSwatchSelected();
      renderCounters();

      triggerEl = document.activeElement;
      refs.backdrop.classList.add('is-open');
      refs.drawer.classList.add('is-open');
      document.documentElement.classList.add('tm-cust-locked');
      document.body.classList.add('tm-cust-locked');
      requestAnimationFrame(function () { refs.drawerBody.scrollTop = 0; });

      setTimeout(function () { refs.drawerClose.focus(); }, 50);

      track('birthstone_drawer_opened', { product: 'toi_moi' });
    }

    function closeDrawer() {
      refs.backdrop.classList.remove('is-open');
      refs.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('tm-cust-locked');
      document.body.classList.remove('tm-cust-locked');
      if (triggerEl && typeof triggerEl.focus === 'function') {
        try { triggerEl.focus(); } catch (e) {}
      }
    }

    refs.gemPillBtn.addEventListener('click', openDrawer);
    refs.drawerClose.addEventListener('click', closeDrawer);
    refs.backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && refs.drawer.classList.contains('is-open')) {
        e.stopPropagation();
        closeDrawer();
      }
    });

    refs.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', refs.drawer).filter(function (n) {
        return !n.hasAttribute('disabled') && n.offsetParent !== null;
      });
      if (!focusables.length) return;
      firstFocusable = focusables[0];
      lastFocusable = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    });

    (function () {
      var startY = null;
      refs.drawer.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 768) return;
        if (refs.drawerBody.scrollTop > 0) return;
        startY = e.touches[0].clientY;
      }, { passive: true });
      refs.drawer.addEventListener('touchmove', function (e) {
        if (startY == null) return;
        var dy = e.touches[0].clientY - startY;
        if (dy > 80) { closeDrawer(); startY = null; }
      }, { passive: true });
      refs.drawer.addEventListener('touchend', function () { startY = null; }, { passive: true });
    })();

    // --- Swatch selection ------------------------------------------------------

    drawerHost.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tm-swatch]');
      if (!btn) return;
      var month = btn.getAttribute('data-tm-swatch');
      var pos = btn.getAttribute('data-tm-position');
      if (!month || !pos) return;

      stopAutoplay();
      if (working[pos] === month) return;

      var prevPos = pos === 'left' ? !!working.left : !!working.right;
      working[pos] = month;
      renderDrawerPreview(working.left, working.right);
      renderPdpRing(working.left, working.right);
      renderSwatchSelected();
      renderCounters();

      var s = stoneByMonth(month);
      var cut = (pos === 'left') ? 'emerald' : 'pear';
      track('birthstone_selected', {
        product: 'toi_moi',
        stone_name: s ? s.stone : '',
        month: s ? s.monthLabel : '',
        position: pos,
        cut: cut
      });
      announce((s ? s.stone : '') + ' selected for ' + (pos === 'left' ? 'birthstone 1' : 'birthstone 2'));

      if (pos === 'left' && !prevPos && refs.section2Heading) {
        try { refs.section2Heading.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
      }
    });

    drawerHost.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-tm-swatch]');
      if (!btn) return;
      var pos = btn.getAttribute('data-tm-position');
      var siblings = $$('[data-tm-position="' + pos + '"]', drawerHost);
      var idx = siblings.indexOf(btn);
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = siblings[(idx + 1) % siblings.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = siblings[(idx - 1 + siblings.length) % siblings.length];
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); btn.click(); return; }
      if (next) { e.preventDefault(); next.focus(); }
    });

    // --- Confirm ---------------------------------------------------------------

    refs.drawerCtaBtn.addEventListener('click', function () {
      if (refs.drawerCtaBtn.disabled) return;
      confirmed.left = working.left;
      confirmed.right = working.right;
      hasConfirmedOnce = true;

      propInputs['Birthstone 1'].value = labelFor(confirmed.left,  'Emerald');
      propInputs['Birthstone 2'].value = labelFor(confirmed.right, 'Pear');

      renderPdpRing(confirmed.left, confirmed.right);
      renderCounters();
      renderAtcState();

      var ls = stoneByMonth(confirmed.left), rs = stoneByMonth(confirmed.right);
      track('birthstone_confirmed', {
        product: 'toi_moi',
        left_stone:  ls ? ls.stone : '',
        left_month:  ls ? ls.monthLabel : '',
        right_stone: rs ? rs.stone : '',
        right_month: rs ? rs.monthLabel : '',
        metal: currentMetal
      });
      closeDrawer();
    });

    // --- ATC interception ------------------------------------------------------
    // Block submit until size + both stones confirmed. Capture-phase listeners
    // run before the theme's own bubble-phase handlers.

    function blockWithReason(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      // Open the customiser if the gemstones aren't confirmed yet
      if (!hasConfirmedOnce) {
        openDrawer();
        return;
      }
      // Otherwise nudge the user to pick a size
      var firstUnchecked = form.querySelector('.product__selectors input[type="radio"]:not(:checked)');
      if (firstUnchecked) {
        var label = form.querySelector('label[for="' + firstUnchecked.id + '"]');
        if (label && label.scrollIntoView) label.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function handleAtcEvent(e) {
      if (e.type === 'click') {
        var t = e.target.closest('[data-add-to-cart]');
        if (!t) return;
      }
      if (!ROOT._tmCanSubmit) { blockWithReason(e); return; }
      // else: let theme proceed with normal AJAX add-to-cart
    }

    form.addEventListener('click', handleAtcEvent, true);
    form.addEventListener('submit', handleAtcEvent, true);

    // --- Tracking --------------------------------------------------------------

    function track(name, params) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          var p = { event: name };
          for (var k in params) if (params.hasOwnProperty(k)) p[k] = params[k];
          window.dataLayer.push(p);
        }
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent('tm:' + name, { bubbles: true, detail: params || {} }));
      } catch (e) {}
    }

    function announce(msg) {
      if (refs.srAnnounce) {
        refs.srAnnounce.textContent = '';
        setTimeout(function () { refs.srAnnounce.textContent = msg; }, 30);
      }
    }

    // --- Cart composite metadata ----------------------------------------------
    // Persist enough metadata for snippets/tm-cart-image-swap.liquid to render
    // the correct composite on cart drawer / /cart. We store the confirmed
    // selection + current metal in localStorage keyed by SESSION_ID, and the
    // cart-line-items snippet exposes that same id via data-tm-session.

    var COMPOSITE_STORAGE_KEY = 'tm_composites';

    function readComposites() {
      try {
        var raw = JSON.parse(localStorage.getItem(COMPOSITE_STORAGE_KEY) || '{}');
        var clean = {};
        Object.keys(raw).forEach(function (k) {
          var v = raw[k];
          if (v && typeof v === 'object' && v.left && v.right && v.metal) clean[k] = v;
        });
        return clean;
      } catch (e) { return {}; }
    }
    function writeComposites(map) {
      try {
        var keys = Object.keys(map);
        if (keys.length > 16) {
          var trimmed = {};
          keys.slice(-16).forEach(function (k) { trimmed[k] = map[k]; });
          map = trimmed;
        }
        localStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map));
      } catch (e) {
        try { sessionStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map)); } catch (e2) {}
      }
    }
    function storeCompositeMeta() {
      var map = readComposites();
      map[SESSION_ID] = {
        left: confirmed.left,
        right: confirmed.right,
        metal: currentMetal
      };
      writeComposites(map);
      try {
        document.dispatchEvent(new CustomEvent('tm:composite:updated', { bubbles: true, detail: { sessionId: SESSION_ID } }));
      } catch (e) {}
    }

    // Persist on Confirm and on ATC click. The metal-change handler also calls
    // storeCompositeMeta() (see applyMetal below).
    refs.drawerCtaBtn.addEventListener('click', function () {
      // Defer so the click handler that updates `confirmed` runs first
      setTimeout(storeCompositeMeta, 0);
    });
    refs.atcBtn.addEventListener('click', function () {
      storeCompositeMeta();
    }, true);

    // --- Metal (variant) sync --------------------------------------------------

    function applyMetal(metal) {
      if (!metal || metal === currentMetal) return;
      currentMetal = metal;

      var pdpL, pdpR;
      if (autoStopped) {
        pdpL = confirmed.left; pdpR = confirmed.right;
      } else {
        var p = (autoIdx >= 0) ? AUTO_PAIRS[autoIdx] : [DEFAULT_LEFT, DEFAULT_RIGHT];
        pdpL = p[0]; pdpR = p[1];
      }
      renderPdpRing(pdpL, pdpR);
      renderDrawerPreview(working.left, working.right);
      // Cart composite is metal-dependent — re-persist so any open cart updates
      storeCompositeMeta();

      track('metal_changed', {
        product: 'toi_moi',
        metal: currentMetal,
        left_stone: stoneName(confirmed.left) || null,
        right_stone: stoneName(confirmed.right) || null
      });
    }

    document.addEventListener('theme:variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      var variantMetal = detectMetalFromVariant(v);
      if (variantMetal) applyMetal(variantMetal);
    });

    // Fallback: direct change events on Color/Finish/etc. option inputs
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name.indexOf('options[') !== 0) return;
      var inputs = form.querySelectorAll('[data-single-option-selector], [name^="options["]');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (el.type === 'radio' && !el.checked) continue;
        var n = normaliseMetal(el.value);
        if (n) { applyMetal(n); return; }
      }
    });

    // Also re-evaluate ATC enabled state on any form change (size selection etc.)
    var idInput = form.querySelector('[name="id"]');
    if (idInput) {
      var mo = new MutationObserver(renderAtcState);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      form.addEventListener('change', function () { setTimeout(renderAtcState, 0); });
    }

    // --- Drawer-open prefetch: warm the same combo in the other two metals ----
    var prefetchedCombos = {};
    function prefetchOtherMetalsForCombo(left, right) {
      VALID_METALS.forEach(function (m) {
        if (m === currentMetal) return;
        [left, right].forEach(function (month) {
          var key = m + ':' + month;
          if (prefetchedCombos[key]) return;
          prefetchedCombos[key] = true;
          var im = new Image();
          im.src = ringUrl(month, 900, m);
        });
      });
    }
    refs.gemPillBtn.addEventListener('click', function () {
      prefetchOtherMetalsForCombo(confirmed.left, confirmed.right);
    });

    // --- After-first-pick prefetch: warm likely next-clicks (other 11 months,
    //     current metal) so a customer who opens, picks, picks again barely waits.
    var firstPickPrefetched = false;
    function prefetchAllMonthsCurrentMetal() {
      if (firstPickPrefetched) return;
      firstPickPrefetched = true;
      STONES.forEach(function (s) {
        var im = new Image();
        im.src = ringUrl(s.month, 900);
      });
    }
    drawerHost.addEventListener('click', function (e) {
      if (e.target.closest('[data-tm-swatch]')) prefetchAllMonthsCurrentMetal();
    }, true);

    // --- First paint -----------------------------------------------------------

    renderPdpRing(confirmed.left, confirmed.right);
    renderDrawerPreview(working.left, working.right);
    renderSwatchSelected();
    propInputs['Birthstone 1'].value = labelFor(confirmed.left,  'Emerald');
    propInputs['Birthstone 2'].value = labelFor(confirmed.right, 'Pear');
    renderCounters();
    renderAtcState();

    // Persist once at init so the default state (March + September, current metal)
    // is already in localStorage even before any explicit interaction.
    storeCompositeMeta();

    startAutoplay();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wavy-birthstone-customiser"]) return;
  try {
    
  (function () {
    'use strict';

    var ROOT = document.querySelector('[data-wb-cust]');
    if (!ROOT) return;

    var configEl = ROOT.querySelector('[data-wb-config]');
    if (!configEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }

    var STONES = CONFIG.stones;
    var RINGS_BY_METAL = CONFIG.rings;
    var EMERALD_SWATCHES = CONFIG.emeraldSwatches;
    var PEAR_SWATCHES = CONFIG.pearSwatches;
    // Diagonal seam config: { top, mid, bottom } each = pct-from-left at
    // that y-position on the image (top edge / midline / bottom edge).
    // Three control points let the seam thread between the emerald cut at
    // the top of the source PNG and the pear at the bottom, hugging the
    // wavy band's curve. Tunable per metal if camera angle varies.
    var DEFAULT_SEAM = { top: 0.30, mid: 0.50, bottom: 0.62 };
    var SEAM_BY_METAL = CONFIG.seamByMetal || { gold: DEFAULT_SEAM, silver: DEFAULT_SEAM, rose_gold: DEFAULT_SEAM };

    // Default state per brief: October (Pink Tourmaline, emerald cut, right) + August (Peridot, pear cut, left)
    var DEFAULT_EMERALD = 'october';
    var DEFAULT_PEAR = 'august';
    var VALID_METALS = ['gold', 'silver', 'rose_gold'];

    var currentMetal = (CONFIG.initialMetal && RINGS_BY_METAL[CONFIG.initialMetal]) ? CONFIG.initialMetal : 'gold';

    function getSeam(metal) {
      var s = SEAM_BY_METAL[metal];
      if (!s || typeof s.top !== 'number' || typeof s.mid !== 'number' || typeof s.bottom !== 'number') {
        return DEFAULT_SEAM;
      }
      return s;
    }

    function normaliseMetal(v) {
      if (!v) return null;
      var m = String(v).trim().toLowerCase().replace(/\s+/g, '_');
      if (m === 'rose_gold' || m === 'silver' || m === 'gold') return m;
      if (m === 'yellow_gold') return 'gold';
      if (m === 'white_gold')  return 'silver';
      return null;
    }

    function detectMetalFromVariant(variant) {
      if (!variant || !variant.options) return null;
      for (var i = 0; i < variant.options.length; i++) {
        var n = normaliseMetal(variant.options[i]);
        if (n) return n;
      }
      return null;
    }

    function ringUrl(month, w, metalOverride) {
      var metal = metalOverride || currentMetal;
      var bucket = RINGS_BY_METAL[metal] || RINGS_BY_METAL.gold;
      var u = bucket && bucket[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 900) : '';
    }
    function emeraldSwatchUrl(month, w) {
      var u = EMERALD_SWATCHES[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 180) : '';
    }
    function pearSwatchUrl(month, w) {
      var u = PEAR_SWATCHES[month];
      return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 180) : '';
    }
    function stoneByMonth(m) {
      for (var i = 0; i < STONES.length; i++) if (STONES[i].month === m) return STONES[i];
      return null;
    }
    function stoneName(m) { var s = stoneByMonth(m); return s ? s.stone : ''; }
    function labelFor(month, cut) {
      // e.g. "Pink Tourmaline (October) — Emerald cut"
      var s = stoneByMonth(month);
      if (!s) return '';
      return s.stone + ' (' + s.monthLabel + ') — ' + cut + ' cut';
    }
    function uid() {
      return 'wb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // --- Mount: clone templates into their final locations ---------------------

    function tpl(name) {
      var t = ROOT.querySelector('[data-wb-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : null;
    }

    var pillsFrag = tpl('pills');
    var drawerFrag = tpl('drawer');
    var propsFrag = tpl('properties');
    if (!pillsFrag || !drawerFrag || !propsFrag) return;

    // 1) Inject hidden line-item-property inputs into the product form
    var form = document.querySelector('form[action*="/cart/add"][data-product-form]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var SESSION_ID = uid();
    var propInputs = {};
    Array.prototype.forEach.call(propsFrag.querySelectorAll('[data-wb-prop]'), function (el) {
      propInputs[el.getAttribute('data-wb-prop')] = el;
    });
    propInputs['_WB Session ID'].value = SESSION_ID;
    form.appendChild(propsFrag);

    // 2) Move pills into the form, BELOW the size selector
    var pillsHost = document.createElement('div');
    pillsHost.className = 'wb-cust wb-cust--pills-host';
    pillsHost.appendChild(pillsFrag);

    var selectorsAnchor = form.querySelector('.product__selectors');
    if (selectorsAnchor) {
      selectorsAnchor.insertAdjacentElement('afterend', pillsHost);
    } else {
      var submit = form.querySelector('.product__submit__holder') || form.querySelector('[data-add-to-cart]');
      if (submit && submit.parentNode) {
        submit.parentNode.insertBefore(pillsHost, submit);
      } else {
        form.appendChild(pillsHost);
      }
    }

    // 3) Mount the ring overlay on the primary gallery slide. Hide every other
    //    variant featured_media slide — the customer sees a single hero image
    //    that updates as they change metal / stones.
    //
    //    Unlike Toi & Moi we DO NOT need to clone slide 1 + preserve the
    //    lifestyle photo, because the merchant uploads lifestyle shots as
    //    additional product media (not as the variant featured_image). The
    //    additional shots remain as their own slides; we only commandeer slide 1.
    function mountOverlayOnSlide(slide) {
      if (!slide || slide.dataset.wbOverlayMounted === '1') return;
      slide.dataset.wbOverlayMounted = '1';
      var slideMedia = slide.querySelector('.product-single__media') || slide;
      var computed = getComputedStyle(slideMedia);
      if (computed.position === 'static') slideMedia.style.position = 'relative';
      // Hide the bare image so only our overlay is visible on this slide.
      // We deliberately keep `.product-single__media-link` in the DOM — it's
      // the theme's zoom anchor; the overlay sits on top with
      // `pointer-events: none` so clicks still pass through to the link.
      var hideSelectors = [
        'figure',
        'picture',
        '.lazy-image',
        'deferred-media',
        '.deferred-media',
        '[data-deferred-media]'
      ].join(', ');
      Array.prototype.forEach.call(slideMedia.querySelectorAll(hideSelectors), function (el) {
        el.style.display = 'none';
      });
      slide.classList.remove('media--hidden');
      var overlayClone = ROOT.querySelector('[data-wb-tpl="overlay"]').content.cloneNode(true);
      slideMedia.appendChild(overlayClone);
    }

    // Find the primary gallery slide and mount the overlay on it. Retry up to
    // ~1.2s in case the gallery DOM hasn't finished rendering when this script
    // runs (depends on theme's section script order). After every successful
    // mount we re-render the PDP so the newly-mounted overlay picks up the
    // current state.
    var mountAttempts = 0;
    var MAX_MOUNT_ATTEMPTS = 12;
    function findSlidesAndMount() {
      var allSlides = Array.prototype.slice.call(document.querySelectorAll('[data-product-single-media-group] [data-product-slide]'));
      var primarySlide = allSlides[0] || null;
      if (!primarySlide) {
        if (++mountAttempts < MAX_MOUNT_ATTEMPTS) {
          setTimeout(findSlidesAndMount, 100);
          return;
        }
        try { console.warn('[wavy-birthstone-customiser] No gallery slide found after ' + (mountAttempts * 100) + 'ms — overlay will not mount; PDP image will not respond to selections.'); } catch (e0) {}
        return;
      }
      mountOverlayOnSlide(primarySlide);
      try { console.log('[wavy-birthstone-customiser] overlay mounted on primary slide', { attempts: mountAttempts + 1, totalSlides: allSlides.length }); } catch (e0) {}

      // Hide additional variant featured_media slides — but only those tagged
      // as media for OTHER variants (not the additional photos the merchant
      // uploaded). Theme marks variant slides with `data-media-id` matching
      // variant.featured_media.id; we leave non-variant media alone.
      var variantMediaIds = {};
      try {
        var variantsData = (window.theme && window.theme.product && window.theme.product.variants) || null;
        if (variantsData) {
          for (var vi = 0; vi < variantsData.length; vi++) {
            var v = variantsData[vi];
            if (v && v.featured_media && v.featured_media.id) {
              variantMediaIds[String(v.featured_media.id)] = true;
            }
          }
        }
      } catch (e) {}
      // If we can't enumerate variants, fall back to hiding nothing — better
      // to show extra slides than to wipe the gallery.
      if (Object.keys(variantMediaIds).length > 1) {
        for (var i = 1; i < allSlides.length; i++) {
          var s = allSlides[i];
          var mid = s.getAttribute('data-media-id') || s.getAttribute('data-id');
          if (mid && variantMediaIds[String(mid)]) {
            s.style.display = 'none';
          }
        }
      }

      // Now that the overlay exists, paint the current ring on it. Guarded
      // because `confirmed` is declared later in the IIFE (via hoisting it's
      // a known identifier, but the object literal hasn't been assigned yet
      // on the synchronous first-try path). The sync path is fine — the
      // first-paint section at the bottom of the IIFE handles it. The async
      // retry path is the one that needs this re-render (because first-paint
      // already ran and didn't find the overlay).
      if (confirmed) {
        try { renderPdpRing(confirmed.emerald, confirmed.pear); } catch (e0) {}
      }
    }
    findSlidesAndMount();

    // 4) Mount the drawer + backdrop on <body>
    var drawerHost = document.createElement('div');
    drawerHost.className = 'wb-cust';
    drawerHost.appendChild(drawerFrag);
    document.body.appendChild(drawerHost);

    // --- DOM refs --------------------------------------------------------------

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    var refs = {
      pills: $('[data-wb="pills"]', pillsHost),
      gemPillBtn: $('[data-wb="open-drawer"]', pillsHost),
      gemPillCounter: $('[data-wb="gem-pill-counter"]', pillsHost),

      pdpComposites: [], pdpLefts: [], pdpRights: [],

      backdrop: $('[data-wb="backdrop"]', drawerHost),
      drawer: $('[data-wb="drawer"]', drawerHost),
      drawerClose: $('[data-wb="drawer-close"]', drawerHost),
      drawerComposite: $('[data-wb="drawer-composite"]', drawerHost),
      drawerLeft:  $('[data-wb="drawer-left"]',  drawerHost),
      drawerRight: $('[data-wb="drawer-right"]', drawerHost),
      drawerBody: $('[data-wb="drawer-body"]', drawerHost),
      sectionEmerald: drawerHost.querySelector('[data-wb-section="emerald"] .wb-cust__grid'),
      sectionPear: drawerHost.querySelector('[data-wb-section="pear"] .wb-cust__grid'),
      section2Heading: $('[data-wb="section-2-heading"]', drawerHost),
      drawerTitleCounter: $('[data-wb="drawer-title-counter"]', drawerHost),
      drawerCtaBtn: $('[data-wb="drawer-confirm"]', drawerHost),
      drawerCtaCounter: $('[data-wb="drawer-cta-counter"]', drawerHost),
      pairTextPear:    $('[data-wb="pair-text-pear"]', drawerHost),
      pairTextEmerald: $('[data-wb="pair-text-emerald"]', drawerHost),
      srAnnounce: $('[data-wb="sr-announce"]', drawerHost),

      atcBtn: form.querySelector('[data-add-to-cart]'),
      atcText: form.querySelector('[data-add-to-cart-text]')
    };

    if (!refs.atcBtn) return;
    var ORIGINAL_ATC_TEXT = refs.atcText ? refs.atcText.textContent : '';

    function refreshPdpRefs() {
      refs.pdpComposites = $$('[data-wb="pdp-composite"]');
      refs.pdpLefts      = $$('[data-wb="pdp-left"]');
      refs.pdpRights     = $$('[data-wb="pdp-right"]');
    }
    refreshPdpRefs();

    // --- Build swatch grids ----------------------------------------------------

    function buildGrid(container, position, swatchUrlFn, ariaCut) {
      var frag = document.createDocumentFragment();
      STONES.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wb-cust__swatch';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-label', s.monthLabel + ' — ' + s.stone + ' (' + ariaCut + ' cut)');
        btn.setAttribute('data-wb-swatch', s.month);
        btn.setAttribute('data-wb-position', position);
        btn.setAttribute('tabindex', '-1');
        btn.innerHTML =
          '<img class="wb-cust__swatch__img" src="' + swatchUrlFn(s.month, 180) + '" alt="" loading="lazy" width="80" height="80">' +
          '<span class="wb-cust__swatch__label">' + s.monthLabel + '</span>' +
          '<span class="wb-cust__swatch__stone">' + s.stone + '</span>';
        frag.appendChild(btn);
        // Log failed swatch URLs (wrong filename / CDN miss) — silent in
        // production until something breaks, then very loud in DevTools.
        var swatchImg = btn.querySelector('.wb-cust__swatch__img');
        if (swatchImg) {
          swatchImg.addEventListener('error', (function (url, month, cut) {
            return function () {
              try {
                console.warn('[wavy-birthstone-customiser] Swatch failed to load:', cut, month, url);
              } catch (e) {}
            };
          })(swatchUrlFn(s.month, 180), s.month, ariaCut));
        }
      });
      container.appendChild(frag);
    }
    buildGrid(refs.sectionEmerald, 'emerald', emeraldSwatchUrl, 'emerald');
    buildGrid(refs.sectionPear,    'pear',    pearSwatchUrl,    'pear');

    // Diagnostic: log a per-position swatch count so we can sanity-check both
    // grids actually populated with their OWN swatches (not double-stamped
    // emerald swatches into both grids etc.).
    try {
      var emeraldSwatchCount = drawerHost.querySelectorAll('[data-wb-position="emerald"]').length;
      var pearSwatchCount    = drawerHost.querySelectorAll('[data-wb-position="pear"]').length;
      console.log('[wavy-birthstone-customiser] init OK', {
        emeraldSwatches: emeraldSwatchCount,
        pearSwatches: pearSwatchCount,
        expectedPerGrid: STONES.length,
        initialMetal: currentMetal,
        defaults: { pear: 'august', emerald: 'october' }
      });
      if (emeraldSwatchCount !== STONES.length || pearSwatchCount !== STONES.length) {
        console.warn('[wavy-birthstone-customiser] Swatch count mismatch — drawer DOM may have rendered unexpectedly. Expected ' + STONES.length + ' per grid.');
      }
    } catch (e0) {}

    // --- State -----------------------------------------------------------------

    var confirmed = { emerald: DEFAULT_EMERALD, pear: DEFAULT_PEAR };
    var working   = { emerald: DEFAULT_EMERALD, pear: DEFAULT_PEAR };
    var hasConfirmedOnce = false; // pill counter shows 0/2 until first Confirm

    var triggerEl = null; // for focus restore on close

    // --- Autoplay cycle (runs until customer first interacts) ------------------
    // Curated pairs that don't include the default — gives a glance at variety
    // without overshadowing the ad-creative default (October + August).
    var AUTO_PAIRS = [
      ['march', 'november'],   // Aquamarine + Citrine
      ['may',   'december'],   // Emerald + Tanzanite
      ['april', 'september'],  // Diamond + Sapphire
      ['june',  'july']        // Alexandrite + Ruby
    ];
    var AUTO_FRAME_MS = 1100;
    var AUTO_FIRST_DELAY_MS = 700;
    var autoTimer = null;
    var autoStartTimer = null;
    var autoStopped = false;
    var autoIdx = -1;

    function preloadCyclePairs() {
      // Composite uses BOTH the pear-month AND the emerald-month renders.
      // AUTO_PAIRS is [emeraldMonth, pearMonth] — preload both.
      var months = {};
      AUTO_PAIRS.forEach(function (p) { months[p[0]] = 1; months[p[1]] = 1; });
      Object.keys(months).forEach(function (m) {
        var im = new Image();
        im.src = ringUrl(m, 900);
      });
    }

    function startAutoplay() {
      if (autoStopped) return;
      preloadCyclePairs();
      autoStartTimer = setTimeout(function () {
        autoTimer = setInterval(autoTick, AUTO_FRAME_MS);
        autoTick();
      }, AUTO_FIRST_DELAY_MS);
    }

    function autoTick() {
      if (autoStopped) return;
      if (document.hidden) return;
      autoIdx = (autoIdx + 1) % AUTO_PAIRS.length;
      var p = AUTO_PAIRS[autoIdx];
      renderPdpRing(p[0], p[1]);
    }

    function stopAutoplay() {
      if (autoStopped) return;
      autoStopped = true;
      if (autoStartTimer) { clearTimeout(autoStartTimer); autoStartTimer = null; }
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      renderPdpRing(confirmed.emerald, confirmed.pear);
    }

    // --- Renderers -------------------------------------------------------------

    function applySeamToComposite(compositeEl, metal) {
      if (!compositeEl) return;
      var s = getSeam(metal);
      compositeEl.style.setProperty('--seam-top-pct',    (s.top    * 100) + '%');
      compositeEl.style.setProperty('--seam-mid-pct',    (s.mid    * 100) + '%');
      compositeEl.style.setProperty('--seam-bottom-pct', (s.bottom * 100) + '%');
    }

    // Diagnostic: when a ring asset fails to load (404 / CDN error / typo in
    // brief), log the URL. Without this, a broken URL silently keeps the
    // previous image visible — looking like "this stone isn't updating".
    function ensureImgErrorLogging(img) {
      if (!img || img.dataset.wbDiag === '1') return;
      img.dataset.wbDiag = '1';
      img.addEventListener('error', function () {
        try {
          var src = img.currentSrc || img.src || '(empty)';
          console.warn('[wavy-birthstone-customiser] Ring asset failed to load:', src);
        } catch (e) {}
      });
    }

    // Render a single composite (PDP overlay or drawer preview).
    //
    // DUET LAYOUT — INVERTED FROM TOI & MOI:
    //   LEFT half of the visible image  = PEAR stone  (left side of ring)
    //   RIGHT half of the visible image = EMERALD stone (right side of ring)
    //
    // Same-stone fast path: BOTH halves get the same source URL. The clip-path
    // halves overlap perfectly, producing a seamless single image with no
    // compositing artifact (browser caches the second image load — only one
    // network request).
    function renderComposite(compositeEl, leftImg, rightImg, emerald, pear, metal, width) {
      if (!compositeEl) return;
      var m = metal || currentMetal;
      var w = width || 900;
      applySeamToComposite(compositeEl, m);
      ensureImgErrorLogging(leftImg);
      ensureImgErrorLogging(rightImg);
      var ps = stoneByMonth(pear);
      var es = stoneByMonth(emerald);
      if (pear === emerald) {
        var url = ringUrl(pear, w, m);
        if (leftImg)  { leftImg.src  = url; if (ps) leftImg.alt  = ps.stone; }
        if (rightImg) { rightImg.src = url; if (ps) rightImg.alt = ps.stone; }
      } else {
        if (leftImg)  { leftImg.src  = ringUrl(pear,    w, m); if (ps) leftImg.alt  = ps.stone; }
        if (rightImg) { rightImg.src = ringUrl(emerald, w, m); if (es) rightImg.alt = es.stone; }
      }
    }

    function renderPdpRing(emerald, pear) {
      refreshPdpRefs();
      var leftUrl  = ringUrl(pear,    900, currentMetal);
      var rightUrl = ringUrl(emerald, 900, currentMetal);
      var seam = getSeam(currentMetal);
      try { console.log('[wavy-birthstone-customiser] renderPdpRing', { emerald: emerald, pear: pear, metal: currentMetal, seamTop: seam.top, seamMid: seam.mid, seamBottom: seam.bottom, overlayCompositeCount: refs.pdpComposites.length, leftHalfUrl: leftUrl, rightHalfUrl: rightUrl }); } catch (e) {}
      for (var i = 0; i < refs.pdpComposites.length; i++) {
        renderComposite(refs.pdpComposites[i], refs.pdpLefts[i], refs.pdpRights[i], emerald, pear, currentMetal, 900);
      }
    }

    function renderDrawerPreview(emerald, pear) {
      // Drawer preview always uses the customer's currently-selected metal.
      // 600px is plenty — preview is at most ~240px wide.
      renderComposite(refs.drawerComposite, refs.drawerLeft, refs.drawerRight, emerald, pear, currentMetal, 600);
    }

    function pairTextFor(month, fallback) {
      var s = stoneByMonth(month);
      if (!s) return fallback || '—';
      return s.stone + ' (' + s.monthLabel + ')';
    }

    function renderPairText() {
      if (refs.pairTextPear)    refs.pairTextPear.textContent    = pairTextFor(working.pear);
      if (refs.pairTextEmerald) refs.pairTextEmerald.textContent = pairTextFor(working.emerald);
    }

    function renderSwatchSelected() {
      ['emerald', 'pear'].forEach(function (pos) {
        var current = working[pos];
        $$('[data-wb-position="' + pos + '"]', drawerHost).forEach(function (b) {
          var checked = b.getAttribute('data-wb-swatch') === current;
          b.setAttribute('aria-checked', checked ? 'true' : 'false');
          b.setAttribute('tabindex', checked ? '0' : '-1');
        });
      });
    }

    function workingCount() {
      var n = 0; if (working.emerald) n++; if (working.pear) n++; return n;
    }
    function confirmedCount() {
      if (!hasConfirmedOnce) return 0;
      var n = 0; if (confirmed.emerald) n++; if (confirmed.pear) n++; return n;
    }

    function renderCounters() {
      var w = workingCount();
      var c = confirmedCount();
      refs.drawerTitleCounter.textContent = w + '/2';
      refs.drawerCtaCounter.textContent = w + '/2';
      refs.gemPillCounter.textContent = c + '/2';
      refs.drawerCtaBtn.disabled = (w < 2);
    }

    function renderAtcState() {
      // Conditions:
      //   1) size selected (or product has only default variant)
      //   2) both gemstones confirmed (default state pre-fills, but counter only
      //      shows 2/2 after first explicit Confirm — same pattern as Toi & Moi)
      var sizeOk = isSizeSelected();
      var stonesOk = hasConfirmedOnce && !!(confirmed.emerald && confirmed.pear);

      if (refs.atcText) refs.atcText.textContent = ORIGINAL_ATC_TEXT;

      ROOT._wbCanSubmit = sizeOk && stonesOk;
    }

    function isSizeSelected() {
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return false;
      var v = idInput.value;
      if (!v) return false;
      var groups = {};
      $$('.product__selectors input[type="radio"]', form).forEach(function (r) {
        groups[r.name] = groups[r.name] || { any: false };
        if (r.checked) groups[r.name].any = true;
      });
      for (var k in groups) if (groups.hasOwnProperty(k) && !groups[k].any) return false;
      return true;
    }

    // --- Drawer open/close -----------------------------------------------------

    var lastFocusable = null;
    var firstFocusable = null;

    function openDrawer() {
      stopAutoplay();

      working.emerald = confirmed.emerald;
      working.pear = confirmed.pear;
      renderDrawerPreview(working.emerald, working.pear);
      renderSwatchSelected();
      renderPairText();
      renderCounters();

      triggerEl = document.activeElement;
      refs.backdrop.classList.add('is-open');
      refs.drawer.classList.add('is-open');
      document.documentElement.classList.add('wb-cust-locked');
      document.body.classList.add('wb-cust-locked');
      requestAnimationFrame(function () { refs.drawerBody.scrollTop = 0; });

      setTimeout(function () { refs.drawerClose.focus(); }, 50);

      track('birthstone_drawer_opened', { product: 'duet' });
    }

    function closeDrawer() {
      refs.backdrop.classList.remove('is-open');
      refs.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('wb-cust-locked');
      document.body.classList.remove('wb-cust-locked');
      if (triggerEl && typeof triggerEl.focus === 'function') {
        try { triggerEl.focus(); } catch (e) {}
      }
    }

    refs.gemPillBtn.addEventListener('click', openDrawer);
    refs.drawerClose.addEventListener('click', closeDrawer);
    refs.backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && refs.drawer.classList.contains('is-open')) {
        e.stopPropagation();
        closeDrawer();
      }
    });

    refs.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', refs.drawer).filter(function (n) {
        return !n.hasAttribute('disabled') && n.offsetParent !== null;
      });
      if (!focusables.length) return;
      firstFocusable = focusables[0];
      lastFocusable = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    });

    (function () {
      var startY = null;
      refs.drawer.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 768) return;
        if (refs.drawerBody.scrollTop > 0) return;
        startY = e.touches[0].clientY;
      }, { passive: true });
      refs.drawer.addEventListener('touchmove', function (e) {
        if (startY == null) return;
        var dy = e.touches[0].clientY - startY;
        if (dy > 80) { closeDrawer(); startY = null; }
      }, { passive: true });
      refs.drawer.addEventListener('touchend', function () { startY = null; }, { passive: true });
    })();

    // --- Swatch selection ------------------------------------------------------

    drawerHost.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wb-swatch]');
      if (!btn) return;
      var month = btn.getAttribute('data-wb-swatch');
      var pos = btn.getAttribute('data-wb-position');
      // Diagnostic logging — paste DevTools console output if swatches misbehave.
      try { console.log('[wavy-birthstone-customiser] swatch click', { pos: pos, month: month, btn: btn }); } catch (e0) {}
      if (!month || !pos) {
        try { console.warn('[wavy-birthstone-customiser] swatch missing month/pos attr', { month: month, pos: pos }); } catch (e0) {}
        return;
      }

      stopAutoplay();
      if (working[pos] === month) {
        try { console.log('[wavy-birthstone-customiser] swatch already selected — no-op', { pos: pos, month: month }); } catch (e0) {}
        return;
      }

      var prevPos = pos === 'emerald' ? !!working.emerald : !!working.pear;
      working[pos] = month;
      try { console.log('[wavy-birthstone-customiser] working state after click', JSON.parse(JSON.stringify(working))); } catch (e0) {}
      renderDrawerPreview(working.emerald, working.pear);
      renderPdpRing(working.emerald, working.pear);
      renderSwatchSelected();
      renderPairText();
      renderCounters();

      var s = stoneByMonth(month);
      track('birthstone_selected', {
        product: 'duet',
        stone_name: s ? s.stone : '',
        month: s ? s.monthLabel : '',
        position: pos,
        cut: pos
      });
      announce((s ? s.stone : '') + ' selected for ' + (pos === 'emerald' ? 'birthstone 1' : 'birthstone 2'));

      // When Birthstone 1 (pear, now first section) is picked, scroll to
      // Birthstone 2 (emerald section). Note: defaults are pre-filled, so
      // this only fires if the customer reset working.pear to falsy first
      // (rare); kept for symmetry with Toi & Moi.
      if (pos === 'pear' && !prevPos && refs.section2Heading) {
        try { refs.section2Heading.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
      }
    });

    drawerHost.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-wb-swatch]');
      if (!btn) return;
      var pos = btn.getAttribute('data-wb-position');
      var siblings = $$('[data-wb-position="' + pos + '"]', drawerHost);
      var idx = siblings.indexOf(btn);
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = siblings[(idx + 1) % siblings.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = siblings[(idx - 1 + siblings.length) % siblings.length];
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); btn.click(); return; }
      if (next) { e.preventDefault(); next.focus(); }
    });

    // --- Confirm ---------------------------------------------------------------

    refs.drawerCtaBtn.addEventListener('click', function () {
      if (refs.drawerCtaBtn.disabled) return;
      confirmed.emerald = working.emerald;
      confirmed.pear = working.pear;
      hasConfirmedOnce = true;

      propInputs['Birthstone 1'].value = labelFor(confirmed.pear,    'Pear');
      propInputs['Birthstone 2'].value = labelFor(confirmed.emerald, 'Emerald');

      renderPdpRing(confirmed.emerald, confirmed.pear);
      renderCounters();
      renderAtcState();

      var es = stoneByMonth(confirmed.emerald), ps = stoneByMonth(confirmed.pear);
      track('birthstone_confirmed', {
        product: 'duet',
        emerald_stone: es ? es.stone : '',
        emerald_month: es ? es.monthLabel : '',
        pear_stone:    ps ? ps.stone : '',
        pear_month:    ps ? ps.monthLabel : '',
        metal: currentMetal
      });
      closeDrawer();
    });

    // --- ATC interception ------------------------------------------------------
    // Block submit until size + both stones confirmed. Capture-phase listeners
    // run before the theme's bubble-phase handlers.

    function blockWithReason(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!hasConfirmedOnce) {
        openDrawer();
        return;
      }
      var firstUnchecked = form.querySelector('.product__selectors input[type="radio"]:not(:checked)');
      if (firstUnchecked) {
        var label = form.querySelector('label[for="' + firstUnchecked.id + '"]');
        if (label && label.scrollIntoView) label.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function handleAtcEvent(e) {
      if (e.type === 'click') {
        var t = e.target.closest('[data-add-to-cart]');
        if (!t) return;
      }
      if (!ROOT._wbCanSubmit) { blockWithReason(e); return; }
    }

    form.addEventListener('click', handleAtcEvent, true);
    form.addEventListener('submit', handleAtcEvent, true);

    // --- Tracking --------------------------------------------------------------

    function track(name, params) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          var p = { event: name };
          for (var k in params) if (params.hasOwnProperty(k)) p[k] = params[k];
          window.dataLayer.push(p);
        }
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent('wb:' + name, { bubbles: true, detail: params || {} }));
      } catch (e) {}
    }

    function announce(msg) {
      if (refs.srAnnounce) {
        refs.srAnnounce.textContent = '';
        setTimeout(function () { refs.srAnnounce.textContent = msg; }, 30);
      }
    }

    // --- Cart image metadata ---------------------------------------------------
    // Persist enough metadata for snippets/wavy-cart-image-swap.liquid to render
    // the correct ring on cart drawer / /cart. Store the confirmed selection +
    // current metal in localStorage keyed by SESSION_ID; the cart-line-items
    // snippet exposes the same id via data-wb-session on each cart line.

    var COMPOSITE_STORAGE_KEY = 'wb_composites';

    function readComposites() {
      try {
        var raw = JSON.parse(localStorage.getItem(COMPOSITE_STORAGE_KEY) || '{}');
        var clean = {};
        Object.keys(raw).forEach(function (k) {
          var v = raw[k];
          if (v && typeof v === 'object' && v.emerald && v.pear && v.metal) clean[k] = v;
        });
        return clean;
      } catch (e) { return {}; }
    }
    function writeComposites(map) {
      try {
        var keys = Object.keys(map);
        if (keys.length > 16) {
          var trimmed = {};
          keys.slice(-16).forEach(function (k) { trimmed[k] = map[k]; });
          map = trimmed;
        }
        localStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map));
      } catch (e) {
        try { sessionStorage.setItem(COMPOSITE_STORAGE_KEY, JSON.stringify(map)); } catch (e2) {}
      }
    }
    function storeCompositeMeta() {
      var map = readComposites();
      map[SESSION_ID] = {
        emerald: confirmed.emerald,
        pear: confirmed.pear,
        metal: currentMetal
      };
      writeComposites(map);
      try {
        document.dispatchEvent(new CustomEvent('wb:composite:updated', { bubbles: true, detail: { sessionId: SESSION_ID } }));
      } catch (e) {}
    }

    // Persist on Confirm and on ATC click. Metal-change handler also calls
    // storeCompositeMeta() (see applyMetal below).
    refs.drawerCtaBtn.addEventListener('click', function () {
      setTimeout(storeCompositeMeta, 0);
    });
    refs.atcBtn.addEventListener('click', function () {
      storeCompositeMeta();
    }, true);

    // --- Metal (variant) sync --------------------------------------------------

    function applyMetal(metal) {
      if (!metal || metal === currentMetal) return;
      currentMetal = metal;

      var pdpE, pdpP;
      if (autoStopped) {
        pdpE = confirmed.emerald; pdpP = confirmed.pear;
      } else {
        var p = (autoIdx >= 0) ? AUTO_PAIRS[autoIdx] : [DEFAULT_EMERALD, DEFAULT_PEAR];
        pdpE = p[0]; pdpP = p[1];
      }
      renderPdpRing(pdpE, pdpP);
      renderDrawerPreview(working.emerald, working.pear);
      // Cart image is metal-dependent — re-persist so any open cart updates.
      storeCompositeMeta();

      track('metal_changed', {
        product: 'duet',
        metal: currentMetal,
        emerald_stone: stoneName(confirmed.emerald) || null,
        pear_stone:    stoneName(confirmed.pear) || null
      });
    }

    document.addEventListener('theme:variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      var variantMetal = detectMetalFromVariant(v);
      if (variantMetal) applyMetal(variantMetal);
    });

    // Fallback: direct change events on Color/Finish option inputs
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name.indexOf('options[') !== 0) return;
      var inputs = form.querySelectorAll('[data-single-option-selector], [name^="options["]');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (el.type === 'radio' && !el.checked) continue;
        var n = normaliseMetal(el.value);
        if (n) { applyMetal(n); return; }
      }
    });

    // Re-evaluate ATC enabled state on any form change (size selection etc.)
    var idInput = form.querySelector('[name="id"]');
    if (idInput) {
      var mo = new MutationObserver(renderAtcState);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      form.addEventListener('change', function () { setTimeout(renderAtcState, 0); });
    }

    // --- Drawer-open prefetch: warm the same combo in the other two metals ----
    // Composite uses BOTH pear-month AND emerald-month renders — preload both
    // in each non-current metal so a metal-switch inside the drawer is instant.
    var prefetchedCombos = {};
    function prefetchOtherMetalsForCombo(emerald, pear) {
      VALID_METALS.forEach(function (m) {
        if (m === currentMetal) return;
        [emerald, pear].forEach(function (month) {
          var key = m + ':' + month;
          if (prefetchedCombos[key]) return;
          prefetchedCombos[key] = true;
          var im = new Image();
          im.src = ringUrl(month, 900, m);
        });
      });
    }
    refs.gemPillBtn.addEventListener('click', function () {
      prefetchOtherMetalsForCombo(confirmed.emerald, confirmed.pear);
    });

    // --- After-first-pick prefetch: warm likely next-clicks (other 11 months,
    //     current metal) so a customer who opens, picks, picks again barely waits.
    var firstPickPrefetched = false;
    function prefetchAllMonthsCurrentMetal() {
      if (firstPickPrefetched) return;
      firstPickPrefetched = true;
      STONES.forEach(function (s) {
        var im = new Image();
        im.src = ringUrl(s.month, 900);
      });
    }
    drawerHost.addEventListener('click', function (e) {
      if (e.target.closest('[data-wb-swatch]')) prefetchAllMonthsCurrentMetal();
    }, true);

    // --- First paint -----------------------------------------------------------

    renderPdpRing(confirmed.emerald, confirmed.pear);
    renderDrawerPreview(working.emerald, working.pear);
    renderSwatchSelected();
    renderPairText();
    propInputs['Birthstone 1'].value = labelFor(confirmed.pear,    'Pear');
    propInputs['Birthstone 2'].value = labelFor(confirmed.emerald, 'Emerald');
    renderCounters();
    renderAtcState();

    // Persist once at init so the default state is already in localStorage
    // before any explicit interaction.
    storeCompositeMeta();

    startAutoplay();

  })();

  } catch(e) { console.error(e); }
})();
})();
